
// // pages/Products.js
// import React, { useState, useEffect, useRef } from "react";
// import axios from 'axios';
// import { useNavigate } from "react-router-dom";

// // SVG Icons as components
// const SearchIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <circle cx="11" cy="11" r="8" />
//     <path d="m21 21-4.35-4.35" />
//   </svg>
// );

// const PhoneIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
//   </svg>
// );

// const ShoppingCartIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <circle cx="9" cy="21" r="1" />
//     <circle cx="20" cy="21" r="1" />
//     <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//   </svg>
// );

// const HeartIcon = ({ filled = false }) => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill={filled ? "#447793" : "none"}
//     stroke={filled ? "#447793" : "currentColor"}
//     strokeWidth="2"
//   >
//     <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
//   </svg>
// );

// const CompareIcon = () => (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//     <polyline points="7 10 12 15 17 10" />
//     <line x1="12" y1="15" x2="12" y2="3" />
//   </svg>
// );

// const MenuIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <line x1="3" y1="12" x2="21" y2="12" />
//     <line x1="3" y1="6" x2="21" y2="6" />
//     <line x1="3" y1="18" x2="21" y2="18" />
//   </svg>
// );

// const ChatIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
//   </svg>
// );

// const XIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <line x1="18" y1="6" x2="6" y2="18" />
//     <line x1="6" y1="6" x2="18" y2="18" />
//   </svg>
// );

// const ChevronRight = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//   >
//     <polyline points="9 18 15 12 9 6" />
//   </svg>
// );

// const WhatsAppIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="currentColor"
//     stroke="none"
//   >
//     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.473-.149-.673.149-.2.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
//     <path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.553 4.121 1.519 5.863L.049 23.95l6.136-1.452A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.844 0-3.589-.498-5.09-1.374l-.365-.216-3.643.864.868-3.6-.228-.38A9.96 9.96 0 0 1 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"/>
//   </svg>
// );

// const CallIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 24 24"
//     fill="currentColor"
//     stroke="none"
//   >
//     <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
//   </svg>
// );

// // FREE DEMO MODAL COMPONENT
// const FreeDemoModal = ({ isOpen, onClose, product, onSubmit }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     address: '',
//     city: '',
//     pincode: '',
//     preferredDate: '',
//     preferredTime: 'morning',
//     message: '',
//     productName: product?.name || '',
//     productId: product?.id || '',
//     status: 'pending'
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   useEffect(() => {
//     if (product) {
//       setFormData(prev => ({
//         ...prev,
//         productName: product.name,
//         productId: product.id
//       }));
//     }
//   }, [product]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
    
//     try {
//       await onSubmit(formData);
//       setSubmitted(true);
//       setTimeout(() => {
//         setSubmitted(false);
//         onClose();
//         // Reset form
//         setFormData({
//           name: '',
//           phone: '',
//           email: '',
//           address: '',
//           city: '',
//           pincode: '',
//           preferredDate: '',
//           preferredTime: 'morning',
//           message: '',
//           productName: product?.name || '',
//           productId: product?.id || '',
//           status: 'pending'
//         });
//       }, 3000);
//     } catch (error) {
//       console.error('Error submitting demo request:', error);
//       alert('Failed to submit demo request. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div style={{
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(6, 18, 33, 0.7)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       zIndex: 10000,
//       padding: '20px',
//       fontFamily: 'Cambria, serif'
//     }}>
//       <div style={{
//         backgroundColor: 'white',
//         borderRadius: '15px',
//         maxWidth: '600px',
//         width: '100%',
//         maxHeight: '90vh',
//         overflowY: 'auto',
//         boxShadow: '0 20px 40px rgba(6, 18, 33, 0.3)',
//         position: 'relative',
//         animation: 'fadeIn 0.3s ease'
//       }}>
//         {/* Header */}
//         <div style={{
//           background: 'linear-gradient(135deg, #447793, #2D5A74)',
//           color: 'white',
//           padding: '20px 25px',
//           borderRadius: '15px 15px 0 0',
//           position: 'sticky',
//           top: 0,
//           zIndex: 10
//         }}>
//           <button
//             onClick={onClose}
//             style={{
//               position: 'absolute',
//               top: '15px',
//               right: '15px',
//               background: 'rgba(255,255,255,0.2)',
//               border: 'none',
//               color: 'white',
//               fontSize: '20px',
//               cursor: 'pointer',
//               width: '35px',
//               height: '35px',
//               borderRadius: '50%',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center'
//             }}
//           >
//             ×
//           </button>
//           <h2 style={{ margin: 0, fontSize: '1.8rem' }}>📞 Free Demo & Site Visit</h2>
//           <p style={{ margin: '5px 0 0', opacity: 0.9 }}>
//             {product?.name ? `For: ${product.name}` : 'Solar Product Consultation'}
//           </p>
//         </div>

//         {submitted ? (
//           <div style={{
//             padding: '40px',
//             textAlign: 'center'
//           }}>
//             <div style={{
//               fontSize: '4rem',
//               marginBottom: '20px',
//               color: '#447793'
//             }}>✅</div>
//             <h3 style={{ color: '#123249', marginBottom: '15px' }}>
//               Demo Request Submitted Successfully!
//             </h3>
//             <p style={{ color: '#2D5A74', marginBottom: '20px' }}>
//               Thank you for your interest! Our solar expert will contact you within 24 hours to schedule your free demo and site visit.
//             </p>
//             <p style={{ color: '#447793', fontWeight: 'bold' }}>
//               A confirmation has been sent to your email.
//             </p>
//           </div>
//         ) : (
//           <form onSubmit={handleSubmit} style={{ padding: '25px' }}>
//             {/* Product Info (if specific) */}
//             {product && (
//               <div style={{
//                 backgroundColor: '#DDE8ED',
//                 padding: '15px',
//                 borderRadius: '10px',
//                 marginBottom: '20px',
//                 border: '1px solid #447793'
//               }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
//                   <span style={{ fontSize: '1.5rem' }}>☀️</span>
//                   <div>
//                     <strong style={{ color: '#123249' }}>{product.name}</strong>
//                     <p style={{ margin: '5px 0 0', color: '#2D5A74', fontSize: '0.9rem' }}>
//                       Price: ₹{product.price.toLocaleString()}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Personal Information */}
//             <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px' }}>
//               Personal Information
//             </h4>
            
//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                 Full Name *
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '12px 15px',
//                   border: '1px solid #DDE8ED',
//                   borderRadius: '8px',
//                   fontSize: '1rem',
//                   outline: 'none',
//                   transition: 'border-color 0.3s'
//                 }}
//                 onFocus={(e) => e.target.style.borderColor = '#447793'}
//                 onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                 placeholder="Enter your full name"
//               />
//             </div>

//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   Phone Number *
//                 </label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                   placeholder="10-digit mobile number"
//                   pattern="[0-9]{10}"
//                   maxLength="10"
//                 />
//               </div>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   Email Address
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                   placeholder="your@email.com"
//                 />
//               </div>
//             </div>

//             {/* Location Information */}
//             <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px', marginTop: '25px' }}>
//               Location for Site Visit
//             </h4>

//             <div style={{ marginBottom: '15px' }}>
//               <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                 Address *
//               </label>
//               <textarea
//                 name="address"
//                 value={formData.address}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '12px 15px',
//                   border: '1px solid #DDE8ED',
//                   borderRadius: '8px',
//                   fontSize: '1rem',
//                   outline: 'none',
//                   minHeight: '80px',
//                   resize: 'vertical'
//                 }}
//                 onFocus={(e) => e.target.style.borderColor = '#447793'}
//                 onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                 placeholder="Enter your complete address for site visit"
//               />
//             </div>

//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   City *
//                 </label>
//                 <input
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                   placeholder="e.g., Mumbai"
//                 />
//               </div>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   Pincode *
//                 </label>
//                 <input
//                   type="text"
//                   name="pincode"
//                   value={formData.pincode}
//                   onChange={handleChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                   placeholder="400001"
//                   pattern="[0-9]{6}"
//                   maxLength="6"
//                 />
//               </div>
//             </div>

//             {/* Preferred Schedule */}
//             <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px', marginTop: '25px' }}>
//               Preferred Schedule
//             </h4>

//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   Preferred Date *
//                 </label>
//                 <input
//                   type="date"
//                   name="preferredDate"
//                   value={formData.preferredDate}
//                   onChange={handleChange}
//                   required
//                   min={new Date().toISOString().split('T')[0]}
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                 />
//               </div>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                   Preferred Time *
//                 </label>
//                 <select
//                   name="preferredTime"
//                   value={formData.preferredTime}
//                   onChange={handleChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '12px 15px',
//                     border: '1px solid #DDE8ED',
//                     borderRadius: '8px',
//                     fontSize: '1rem',
//                     outline: 'none',
//                     backgroundColor: 'white'
//                   }}
//                   onFocus={(e) => e.target.style.borderColor = '#447793'}
//                   onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                 >
//                   <option value="morning">Morning (9 AM - 12 PM)</option>
//                   <option value="afternoon">Afternoon (12 PM - 3 PM)</option>
//                   <option value="evening">Evening (3 PM - 6 PM)</option>
//                 </select>
//               </div>
//             </div>

//             {/* Additional Message */}
//             <div style={{ marginBottom: '25px' }}>
//               <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
//                 Additional Message / Requirements
//               </label>
//               <textarea
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 style={{
//                   width: '100%',
//                   padding: '12px 15px',
//                   border: '1px solid #DDE8ED',
//                   borderRadius: '8px',
//                   fontSize: '1rem',
//                   outline: 'none',
//                   minHeight: '80px',
//                   resize: 'vertical'
//                 }}
//                 onFocus={(e) => e.target.style.borderColor = '#447793'}
//                 onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
//                 placeholder="Tell us about any specific requirements or questions..."
//               />
//             </div>

//             {/* Submit Button */}
//             <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
//               <button
//                 type="button"
//                 onClick={onClose}
//                 style={{
//                   padding: '12px 25px',
//                   backgroundColor: 'transparent',
//                   color: '#123249',
//                   border: '1px solid #447793',
//                   borderRadius: '8px',
//                   fontSize: '1rem',
//                   cursor: 'pointer',
//                   transition: 'all 0.3s'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.backgroundColor = '#DDE8ED';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.backgroundColor = 'transparent';
//                 }}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 style={{
//                   padding: '12px 30px',
//                   backgroundColor: isSubmitting ? '#2D5A74' : '#447793',
//                   color: 'white',
//                   border: 'none',
//                   borderRadius: '8px',
//                   fontSize: '1rem',
//                   fontWeight: '600',
//                   cursor: isSubmitting ? 'not-allowed' : 'pointer',
//                   transition: 'all 0.3s',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '8px'
//                 }}
//                 onMouseEnter={(e) => {
//                   if (!isSubmitting) e.target.style.backgroundColor = '#2D5A74';
//                 }}
//                 onMouseLeave={(e) => {
//                   if (!isSubmitting) e.target.style.backgroundColor = '#447793';
//                 }}
//               >
//                 {isSubmitting ? 'Submitting...' : '📅 Book Free Demo'}
//               </button>
//             </div>

//             <p style={{ marginTop: '20px', fontSize: '0.85rem', color: '#2D5A74', textAlign: 'center' }}>
//               Our solar expert will contact you within 24 hours to confirm your appointment.
//             </p>
//           </form>
//         )}
//       </div>
//     </div>
//   );
// };

// const Products = () => {
//   const navigate = useNavigate();
  
//   // State management
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [searchSuggestions, setSearchSuggestions] = useState([]);
//   const [wishlist, setWishlist] = useState([]);
//   const [enquiryModal, setEnquiryModal] = useState({
//     open: false,
//     product: null,
//   });
//   const [cart, setCart] = useState([]);
//   const [compareList, setCompareList] = useState([]);
//   const [priceRange, setPriceRange] = useState([0, 500000]);
//   const [sortBy, setSortBy] = useState("featured");
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [bestSellingScrollPos, setBestSellingScrollPos] = useState(0);
//   const [showCompareModal, setShowCompareModal] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
//   // Database states
//   const [dbProducts, setDbProducts] = useState([]);
//   const [dbBestSellers, setDbBestSellers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Chatbot states
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [chatMessages, setChatMessages] = useState([]);
//   const [chatInput, setChatInput] = useState("");
//   const [leadCaptured, setLeadCaptured] = useState(false);
//   const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
//   const [leadStep, setLeadStep] = useState(0);
//   const [userData, setUserData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     productInterest: "",
//   });
//   const [messageCount, setMessageCount] = useState(0);
//   const [quickReplies, setQuickReplies] = useState([]);
//   const [chatbotHover, setChatbotHover] = useState(false);

//   // FREE DEMO MODAL STATE
//   const [demoModal, setDemoModal] = useState({
//     open: false,
//     product: null
//   });

//   const scrollContainerRef = useRef(null);
//   const bestSellingRef = useRef(null);
//   const autoScrollRef = useRef(null);

//   // API base URL
//   const API_BASE_URL = 'http://localhost:5000/api';
//   const WHATSAPP_NUMBER = '8421377814';

//   // Static fallback data with proper image paths
//   const productData = [
//     {
//       id: 1,
//       name: "SolarSquare Flexi 300W Panel",
//       description: "High-efficiency monocrystalline solar panel with 21.5% efficiency",
//       fullDescription: "Premium monocrystalline solar panel with anti-reflective coating, superior low-light performance, and 25-year linear power output warranty. Perfect for residential rooftops.",
//       price: 18500,
//       originalPrice: 21500,
//       category: "panels",
//       rating: 4.8,
//       reviews: 124,
//       image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
//       features: ["300W Output", "25-year Warranty", "Weather Resistant", "Easy Installation", "High Efficiency"],
//       tags: ["best-seller", "new-arrival", "featured"],
//       stock: 25,
//       isFeatured: true,
//       specs: { power: "300W", efficiency: "21.5%", warranty: "25 years", dimensions: "175×100 cm", weight: "18 kg" },
//     },
//     {
//       id: 2,
//       name: "SmartSolar Inverter 5kW",
//       description: "Hybrid solar inverter with battery backup",
//       fullDescription: "Smart hybrid inverter with WiFi monitoring, pure sine wave output, and seamless grid-tie functionality. Includes mobile app for real-time monitoring.",
//       price: 45000,
//       originalPrice: 52000,
//       category: "inverters",
//       rating: 4.7,
//       reviews: 89,
//       image: "https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop",
//       features: ["5kW Capacity", "WiFi Monitoring", "Pure Sine Wave", "MPPT Technology", "Grid-tie"],
//       tags: ["featured", "smart-device", "best-seller"],
//       stock: 12,
//       isFeatured: true,
//       specs: { capacity: "5kW", type: "Hybrid", efficiency: "97%", warranty: "5 years", connectivity: "WiFi" },
//     },
//     {
//       id: 3,
//       name: "Solar Battery 150Ah",
//       description: "Deep cycle solar battery with 10-year warranty",
//       fullDescription: "Maintenance-free deep cycle battery designed specifically for solar applications with excellent cycle life and fast charging capability.",
//       price: 16500,
//       originalPrice: 19000,
//       category: "batteries",
//       rating: 4.6,
//       reviews: 156,
//       image: "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=400&h=400&fit=crop",
//       features: ["150Ah Capacity", "Maintenance Free", "Deep Cycle", "10-year Warranty", "Fast Charge"],
//       tags: ["value-pack", "long-life", "featured", "best-seller"],
//       stock: 18,
//       isFeatured: true,
//       specs: { capacity: "150Ah", voltage: "12V", warranty: "10 years", cycles: "2000+", type: "Deep Cycle" },
//     },
//     {
//       id: 4,
//       name: "Solar Charge Controller 60A",
//       description: "MPPT charge controller with LCD display",
//       fullDescription: "Advanced MPPT charge controller with temperature compensation and multiple charging modes for optimal battery health.",
//       price: 8500,
//       originalPrice: 10500,
//       category: "controllers",
//       rating: 4.5,
//       reviews: 67,
//       image: "https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop",
//       features: ["60A Capacity", "MPPT Technology", "LCD Display", "Temperature Compensation", "USB Port"],
//       tags: ["energy-efficient"],
//       stock: 30,
//       isFeatured: false,
//       specs: { capacity: "60A", type: "MPPT", efficiency: "98%", warranty: "3 years", display: "LCD" },
//     },
//     {
//       id: 5,
//       name: "Solar Mounting Structure Kit",
//       description: "Complete roof mounting kit for solar panels",
//       fullDescription: "Galvanized steel mounting structure with all necessary hardware for easy installation on various roof types.",
//       price: 12000,
//       originalPrice: 14500,
//       category: "accessories",
//       rating: 4.4,
//       reviews: 42,
//       image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
//       features: ["Galvanized Steel", "All Hardware Included", "Adjustable Angle", "Wind Resistant", "Corrosion Proof"],
//       tags: ["installation", "hardware"],
//       stock: 22,
//       isFeatured: false,
//       specs: { material: "Galvanized Steel", capacity: "20 panels", warranty: "10 years", adjustment: "0-45 degrees", corrosion: "Rust Proof" },
//     },
//     {
//       id: 6,
//       name: "Solar Home Kit 3kW",
//       description: "Complete solar solution for homes",
//       fullDescription: "Complete package including 6 solar panels, inverter, batteries, and all accessories for 3kW system with professional installation.",
//       price: 185000,
//       originalPrice: 225000,
//       category: "kits",
//       rating: 4.9,
//       reviews: 203,
//       image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
//       features: ["Complete System", "Professional Installation", "5-year Warranty", "24/7 Support", "WiFi Monitoring"],
//       tags: ["complete-solution", "best-seller", "installation-included", "featured"],
//       stock: 8,
//       isFeatured: true,
//       specs: { capacity: "3kW", components: "Full System", warranty: "5 years", installation: "Included", monitoring: "WiFi" },
//     },
//     {
//       id: 7,
//       name: "Solar Water Heater 100L",
//       description: "Solar thermal water heating system",
//       fullDescription: "Efficient solar water heating system with heat retention technology and backup heating for uninterrupted hot water supply.",
//       price: 35000,
//       originalPrice: 42000,
//       category: "heaters",
//       rating: 4.3,
//       reviews: 58,
//       image: "https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=400&h=400&fit=crop",
//       features: ["100L Capacity", "Heat Retention", "Backup Heating", "Energy Saving", "Auto Temperature Control"],
//       tags: ["eco-friendly", "energy-saving"],
//       stock: 15,
//       isFeatured: false,
//       specs: { capacity: "100L", type: "Thermal", warranty: "7 years", backup: "Electric", efficiency: "85%" },
//     },
//     {
//       id: 8,
//       name: "Solar Street Light 30W",
//       description: "Automatic solar-powered street light",
//       fullDescription: "Smart street light with motion sensor, automatic dusk-to-dawn operation, and long battery life for energy-efficient outdoor lighting.",
//       price: 5500,
//       originalPrice: 7500,
//       category: "lighting",
//       rating: 4.2,
//       reviews: 91,
//       image: "https://images.unsplash.com/photo-1572372747522-4c6c8d1f2b5c?w=400&h=400&fit=crop",
//       features: ["30W LED", "Motion Sensor", "Auto On/Off", "2-day Backup", "Weatherproof"],
//       tags: ["outdoor", "smart-lighting"],
//       stock: 45,
//       isFeatured: false,
//       specs: { power: "30W", battery: "Li-ion", warranty: "3 years", sensor: "Motion", autonomy: "2 days" },
//     },
//   ];

//   // Featured products slideshow data - Blue Theme
//   const featuredSlides = [
//     {
//       id: 1,
//       title: "Best Selling Solar Kit",
//       description: "Complete 3kW solar system for homes. Save up to 90% on electricity bills.",
//       productId: 6,
//       bgColor: "#123249",
//       textColor: "white",
//       cta: "View Details",
//     },
//     {
//       id: 2,
//       title: "Premium Solar Panels",
//       description: "300W monocrystalline panels with 25-year warranty. High efficiency in all conditions.",
//       productId: 1,
//       bgColor: "#2D5A74",
//       textColor: "white",
//       cta: "Learn More",
//     },
//     {
//       id: 3,
//       title: "Smart Solar Inverters",
//       description: "Hybrid inverters with WiFi monitoring. Seamless grid-tie functionality.",
//       productId: 2,
//       bgColor: "#447793",
//       textColor: "white",
//       cta: "Explore",
//     },
//     {
//       id: 4,
//       title: "Long-life Solar Batteries",
//       description: "150Ah deep cycle batteries with 10-year warranty. Maintenance-free operation.",
//       productId: 3,
//       bgColor: "#2D5A74",
//       textColor: "white",
//       cta: "Shop Now",
//     },
//   ];

//   // Helper function to get default image based on category
//   const getDefaultImage = (category) => {
//     const categoryMap = {
//       'Solar Panels': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
//       'Inverters': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
//       'Batteries': 'https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=400&h=400&fit=crop',
//       'Controllers': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
//       'Accessories': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
//       'Complete Kits': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
//       'Water Heaters': 'https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=400&h=400&fit=crop',
//       'Solar Lighting': 'https://images.unsplash.com/photo-1572372747522-4c6c8d1f2b5c?w=400&h=400&fit=crop'
//     };
//     return categoryMap[category] || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop';
//   };

//   // Helper function to map category names to IDs
//   const getCategoryId = (categoryName) => {
//     const categoryMap = {
//       'Solar Panels': 'panels',
//       'Inverters': 'inverters',
//       'Batteries': 'batteries',
//       'Controllers': 'controllers',
//       'Accessories': 'accessories',
//       'Complete Kits': 'kits',
//       'Water Heaters': 'heaters',
//       'Solar Lighting': 'lighting',
//       'Other': 'other'
//     };
//     return categoryMap[categoryName] || 'other';
//   };

//   // Fetch products from database
//   const fetchProductsFromDatabase = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${API_BASE_URL}/products/active`);
      
//       if (response.data.success) {
//         const mappedProducts = response.data.data.map(product => ({
//           id: product._id,
//           name: product.name,
//           description: product.description,
//           fullDescription: product.fullDescription || product.description,
//           price: product.price,
//           originalPrice: product.originalPrice || product.price,
//           category: getCategoryId(product.category),
//           rating: product.rating || 4.5,
//           reviews: product.reviews || 0,
//           image: product.imageUrl || getDefaultImage(product.category),
//           features: product.features || [],
//           tags: product.tags || [],
//           stock: product.stock || 0,
//           isFeatured: product.isFeatured || false,
//           isBestSeller: product.isBestSeller || false,
//           specs: product.specifications || {},
//           isActive: product.isActive
//         }));
        
//         setDbProducts(mappedProducts);
//         setProducts(mappedProducts);
//         setFilteredProducts(mappedProducts);
//         setError(null);
//         console.log('Products loaded from database:', mappedProducts.length);
//       } else {
//         setError('Failed to fetch products from server');
//       }
//     } catch (err) {
//       console.error('Error fetching products:', err);
//       setError('Failed to connect to server. Using sample data.');
//       // Use static data as fallback
//       setProducts(productData);
//       setFilteredProducts(productData);
//       setDbProducts(productData);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch best sellers from database
//   const fetchBestSellersFromDatabase = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/products/best-sellers`);
      
//       if (response.data.success) {
//         const mappedBestSellers = response.data.data.map(product => ({
//           id: product._id,
//           name: product.name,
//           description: product.description,
//           price: product.price,
//           originalPrice: product.originalPrice || product.price,
//           category: getCategoryId(product.category),
//           rating: product.rating || 4.5,
//           reviews: product.reviews || 0,
//           image: product.imageUrl || getDefaultImage(product.category),
//           features: product.features || [],
//           tags: product.tags || [],
//           isBestSeller: product.isBestSeller || false,
//           isActive: product.isActive
//         }));
        
//         setDbBestSellers(mappedBestSellers);
//       }
//     } catch (err) {
//       console.error('Error fetching best sellers:', err);
//       // Use static best sellers as fallback
//       const staticBestSellers = productData.filter(p => p.tags.includes("best-seller"));
//       setDbBestSellers(staticBestSellers);
//     }
//   };

//   useEffect(() => {
//     fetchProductsFromDatabase();
//     fetchBestSellersFromDatabase();
//   }, []);

//   // Initialize chat when opened
//   useEffect(() => {
//     if (isChatOpen && chatMessages.length === 0) {
//       initChat();
//     }
//   }, [isChatOpen]);

//   // Close mobile menu when window resize above mobile
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth > 768) {
//         setMobileMenuOpen(false);
//       }
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Prevent body scroll when mobile menu is open
//   useEffect(() => {
//     if (mobileMenuOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [mobileMenuOpen]);

//   // Use database products if available, otherwise use static data
//   const allProducts = dbProducts.length > 0 ? dbProducts : products;
  
//   // Best selling products from database or static
//   const bestSellingProducts = dbBestSellers.length > 0 
//     ? dbBestSellers.map(prod => ({
//         id: prod._id,
//         name: prod.name,
//         description: prod.description,
//         price: prod.price,
//         originalPrice: prod.originalPrice || prod.price,
//         category: prod.category,
//         rating: prod.rating || 4.5,
//         reviews: prod.reviews || 0,
//         image: prod.image || getDefaultImage(prod.category),
//         features: prod.features || [],
//         tags: prod.tags || [],
//         isBestSeller: prod.isBestSeller || false,
//         isActive: prod.isActive
//       }))
//     : productData.filter((p) => p.tags.includes("best-seller"));

//   // Categories Data with proper structure
//   const categoriesData = [
//     { id: "panels", name: "Solar Panels", icon: "☀️", description: "High-efficiency solar panels for residential and commercial use" },
//     { id: "inverters", name: "Inverters", icon: "⚡", description: "Convert DC to AC power with smart monitoring" },
//     { id: "batteries", name: "Batteries", icon: "🔋", description: "Energy storage solutions for backup power" },
//     { id: "controllers", name: "Controllers", icon: "🎛️", description: "Charge controllers for optimal battery management" },
//     { id: "accessories", name: "Accessories", icon: "🔧", description: "Mounting structures and installation accessories" },
//     { id: "kits", name: "Complete Kits", icon: "📦", description: "Complete solar systems with installation" },
//     { id: "heaters", name: "Water Heaters", icon: "♨️", description: "Solar water heating systems" },
//     { id: "lighting", name: "Solar Lighting", icon: "💡", description: "Outdoor and indoor solar lighting" },
//   ];

//   // Update categories when products change
//   useEffect(() => {
//     const updatedCategories = categoriesData.map(cat => ({
//       ...cat,
//       count: allProducts.filter(p => p.category === cat.id).length,
//       products: allProducts.filter(p => p.category === cat.id)
//     }));
//     setCategories(updatedCategories);
//   }, [allProducts]);

//   // Auto slide for featured products
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % featuredSlides.length);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   // Continuous auto-scroll for Best Selling Products
//   useEffect(() => {
//     const scrollContainer = bestSellingRef.current;
//     if (!scrollContainer) return;

//     const scrollWidth = scrollContainer.scrollWidth;
//     const clientWidth = scrollContainer.clientWidth;
//     const maxScroll = scrollWidth - clientWidth;

//     autoScrollRef.current = setInterval(() => {
//       setBestSellingScrollPos((prev) => {
//         if (prev >= maxScroll) {
//           scrollContainer.scrollTo({ left: 0, behavior: "instant" });
//           return 0;
//         } else {
//           const newPos = prev + 1;
//           scrollContainer.scrollTo({ left: newPos, behavior: "smooth" });
//           return newPos;
//         }
//       });
//     }, 30);

//     return () => {
//       if (autoScrollRef.current) {
//         clearInterval(autoScrollRef.current);
//       }
//     };
//   }, [bestSellingProducts]);

//   // Filter and search functionality
//   useEffect(() => {
//     let filtered = [...allProducts];

//     // Filter by category
//     if (selectedCategory !== "all") {
//       filtered = filtered.filter(
//         (product) => product.category === selectedCategory
//       );
//     }

//     // Filter by search query
//     if (searchQuery) {
//       filtered = filtered.filter(
//         (product) =>
//           product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
//           product.category.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     // Filter by price range
//     filtered = filtered.filter(
//       (product) =>
//         product.price >= priceRange[0] && product.price <= priceRange[1]
//     );

//     // Sort products
//     switch (sortBy) {
//       case "price-low":
//         filtered.sort((a, b) => a.price - b.price);
//         break;
//       case "price-high":
//         filtered.sort((a, b) => b.price - a.price);
//         break;
//       case "rating":
//         filtered.sort((a, b) => b.rating - a.rating);
//         break;
//       case "name":
//         filtered.sort((a, b) => a.name.localeCompare(b.name));
//         break;
//       default:
//         // featured - keep original order
//         break;
//     }

//     setFilteredProducts(filtered);

//     // Generate search suggestions
//     if (searchQuery) {
//       const suggestions = allProducts
//         .filter((product) =>
//           product.name.toLowerCase().includes(searchQuery.toLowerCase())
//         )
//         .slice(0, 5);
//       setSearchSuggestions(suggestions);
//     } else {
//       setSearchSuggestions([]);
//     }
//   }, [selectedCategory, searchQuery, priceRange, sortBy, allProducts]);

//   // Chatbot functions
//   const initChat = () => {
//     addChatMessage(
//       "Hi 👋 Welcome to Blue Sky Energy Products! I'm here to help you with product selection, pricing, and solar solutions. How can I assist you today?",
//       "bot"
//     );
//     setTimeout(() => {
//       addChatMessage("Choose an option to get started:", "bot");
//       setQuickReplies([
//         "🏠 Residential Solutions",
//         "🏢 Commercial Solutions",
//         "💰 Price & Discounts",
//         "⚡ Product Comparison",
//         "📦 Complete Kits",
//       ]);
//     }, 800);
//   };

//   const addChatMessage = (text, sender) => {
//     const time = new Date().toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//     const newMessage = {
//       text,
//       sender,
//       time,
//       id: Date.now(),
//     };
//     setChatMessages((prev) => [...prev, newMessage]);
//     if (sender === "user") {
//       setMessageCount((prev) => prev + 1);
//     }
//   };

//   // Keyword Logic for Products Page
//   const matchKeywords = (input) => {
//     const text = input.toLowerCase();

//     if (text.includes("panel") || text.includes("solar panel") || text.includes("300w")) {
//       return "☀️ Solar Panels\n\n• 300W Monocrystalline Panel\n• Price: ₹18,500 (Save ₹3,000)\n• Efficiency: 21.5%\n• Warranty: 25 years\n• Features: Anti-reflective coating, high low-light performance\n• Perfect for: Residential rooftops\n\nWant more details or want to compare with other panels?";
//     }

//     if (text.includes("inverter") || text.includes("5kw") || text.includes("hybrid")) {
//       return "⚡ SmartSolar Inverter 5kW\n\n• Price: ₹45,000 (Save ₹7,000)\n• Type: Hybrid with battery backup\n• Features: WiFi monitoring, pure sine wave\n• Warranty: 5 years\n• Perfect for: Homes & small businesses\n\nIdeal for grid-tie systems with backup!";
//     }

//     if (text.includes("battery") || text.includes("150ah") || text.includes("storage")) {
//       return "🔋 Solar Battery 150Ah\n\n• Price: ₹16,500 (Save ₹2,500)\n• Capacity: 150Ah Deep Cycle\n• Warranty: 10 years\n• Features: Maintenance-free, fast charging\n• Cycles: 2000+\n\nPerfect for backup power and off-grid systems!";
//     }

//     if (text.includes("kit") || text.includes("3kw") || text.includes("complete") || text.includes("system")) {
//       return "📦 Solar Home Kit 3kW\n\n• Price: ₹1,85,000 (Save ₹40,000)\n• Complete system with installation\n• Includes: 6 panels, inverter, batteries\n• Warranty: 5 years comprehensive\n• Savings: Up to 90% on electricity bills\n\nMost popular kit for Indian homes!";
//     }

//     if (text.includes("residential") || text.includes("home") || text.includes("house")) {
//       return "🏠 Residential Solar Solutions\n\nRecommended for homes:\n1. 3kW Complete Kit - ₹1,85,000\n2. 5kW System - ₹2,80,000\n3. 10kW System - ₹5,20,000\n\nAverage ROI: 4-5 years\nMonthly Savings: ₹3,000-₹12,000\nSubsidies Available: 20-40%\n\nNeed a customized quote for your home?";
//     }

//     if (text.includes("commercial") || text.includes("business") || text.includes("factory") || text.includes("industrial")) {
//       return "🏢 Commercial Solar Solutions\n\nRecommended for businesses:\n• 10kW System - ₹5,20,000\n• 20kW System - ₹9,80,000\n• 50kW System - ₹22,00,000\n• 100kW+ Systems - Custom pricing\n\nBenefits: Tax savings, 70% cost reduction, green certification\n\nWant commercial solar details?";
//     }

//     if (text.includes("price") || text.includes("cost") || text.includes("discount") || text.includes("sale")) {
//       return "💰 Price & Discounts\n\nCurrent Offers:\n• Solar Panels: Save ₹3,000\n• Inverters: Save ₹7,000\n• Batteries: Save ₹2,500\n• Complete Kits: Save ₹40,000\n\nFinancing Options:\n• 0% EMI for 6 months\n• Bank loan assistance\n• Subsidy guidance\n\nSpecial: Free installation on kits above 5kW!";
//     }

//     if (text.includes("compare") || text.includes("difference") || text.includes("vs") || text.includes("which")) {
//       return "⚡ Product Comparison\n\nPanel vs Inverter vs Battery:\n• Solar Panel: Generates electricity\n• Inverter: Converts DC to AC\n• Battery: Stores excess power\n• Complete Kit: All components\n\nBest for:\n• Only high bills: Grid-tie system\n• Power cuts: Hybrid system\n• Off-grid: Complete with batteries\n\nNeed help choosing?";
//     }

//     if (text.includes("warranty") || text.includes("guarantee") || text.includes("quality")) {
//       return "✅ Quality & Warranty\n\nOur Guarantees:\n• Solar Panels: 25 years\n• Inverters: 5 years\n• Batteries: 10 years\n• Installation: 5 years\n• Complete Systems: 5 years comprehensive\n\nAll products: ISO certified, grade-A materials\nFree maintenance for first year!";
//     }

//     if (text.includes("installation") || text.includes("install") || text.includes("setup")) {
//       return "🔧 Installation Services\n\n• Professional certified installers\n• Site survey & design\n• Complete installation in 3-7 days\n• Government approval assistance\n• Subsidy application help\n• Free maintenance training\n\nWe handle everything from A to Z!";
//     }

//     if (text.includes("subsidy") || text.includes("government") || text.includes("scheme") || text.includes("incentive")) {
//       return "🏛️ Government Subsidies\n\nAvailable Subsidies:\n• Residential: 20-40%\n• Commercial: 30% for MSME\n• Agricultural: Up to 50%\n• Rooftop Solar: Additional benefits\n\nWe Provide:\n• Complete subsidy application\n• Document preparation\n• Follow-up with authorities\n• 100% subsidy success rate!";
//     }

//     if (text.includes("emi") || text.includes("finance") || text.includes("loan") || text.includes("payment")) {
//       return "💳 Payment Options\n\n• Cash/Card/UPI: Full payment\n• EMI: 0% for 6 months\n• Bank Loans: We provide assistance\n• Corporate Credit: Available\n• Flexible Payments: 50% advance, 50% after installation\n\nNo cost EMI on all products above ₹50,000!";
//     }

//     return `I understand you're interested in solar products! Blue Sky Energy offers ${allProducts.length} products including:\n• Solar Panels (300W to 500W)\n• Inverters (1kW to 100kW)\n• Batteries (50Ah to 200Ah)\n• Complete Home Kits\n• Commercial Systems\n• Installation Services\n\nWhat specific product or information are you looking for?`;
//   };

//   // Lead Capture Logic for Product Enquiries
//   const handleLeadCapture = (input) => {
//     if (leadStep === 0) {
//       setUserData((prev) => ({ ...prev, name: input }));
//       setLeadStep(1);
//       addChatMessage(
//         `Nice to meet you, ${input}! 😊\n\nWhich solar product are you most interested in?`,
//         "bot"
//       );
//     } else if (leadStep === 1) {
//       setUserData((prev) => ({ ...prev, productInterest: input }));
//       setLeadStep(2);
//       addChatMessage(
//         "Great choice! Could you please share your email address for detailed information?",
//         "bot"
//       );
//     } else if (leadStep === 2) {
//       setUserData((prev) => ({ ...prev, email: input }));
//       setLeadStep(3);
//       addChatMessage(
//         "Perfect! And what's your phone number so our solar expert can contact you?",
//         "bot"
//       );
//     } else if (leadStep === 3) {
//       setUserData((prev) => ({ ...prev, phone: input }));
//       setLeadCaptured(true);
//       setAwaitingLeadInfo(false);
//       saveEnquiry({ ...userData, phone: input });
//       addChatMessage(
//         `Excellent! Thank you ${userData.name}! ✅\n\nEnquiry received for: ${userData.productInterest}\n\nOur solar expert will contact you within 24 hours with:\n1. Detailed product information\n2. Customized pricing\n3. Subsidy details\n4. Installation timeline\n\nWelcome to Blue Sky Energy! 🌞`,
//         "bot"
//       );
//     }
//   };

//   const saveEnquiry = (data) => {
//     const enquiryId = `product_enquiry_${Date.now()}`;
//     localStorage.setItem(
//       enquiryId,
//       JSON.stringify({
//         ...data,
//         timestamp: new Date(),
//         source: "products_chatbot",
//       })
//     );
//     console.log("Product Enquiry Saved:", data);
//   };

//   const handleChatSend = () => {
//     const text = chatInput.trim();
//     if (!text) return;

//     addChatMessage(text, "user");
//     setChatInput("");
//     setQuickReplies([]);

//     setTimeout(() => {
//       if (awaitingLeadInfo) {
//         handleLeadCapture(text);
//       } else {
//         const response = matchKeywords(text);
//         addChatMessage(response, "bot");

//         // Trigger Lead Capture after 2 interactions
//         if (!leadCaptured && messageCount >= 1) {
//           setTimeout(() => {
//             addChatMessage(
//               "Want detailed pricing and expert advice? 📋\n\nWhat's your name?",
//               "bot"
//             );
//             setAwaitingLeadInfo(true);
//           }, 1500);
//         }
//       }
//     }, 600);
//   };

//   const handleQuickReply = (option) => {
//     setChatInput(option);
//     setTimeout(() => {
//       handleChatSend();
//     }, 100);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleChatSend();
//     }
//   };

//   // Handle search
//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   // Handle category selection
//   const handleCategorySelect = (categoryId) => {
//     setSelectedCategory(categoryId);
//     setMobileMenuOpen(false);
//     // Scroll to category section
//     const element = document.getElementById(`category-${categoryId}`);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   // Wishlist functionality
//   const toggleWishlist = (productId) => {
//     if (wishlist.includes(productId)) {
//       setWishlist(wishlist.filter((id) => id !== productId));
//     } else {
//       setWishlist([...wishlist, productId]);
//     }
//   };

//   // Cart functionality
//   const addToCart = (product) => {
//     const existingItem = cart.find((item) => item.id === product.id);
//     if (existingItem) {
//       setCart(
//         cart.map((item) =>
//           item.id === product.id
//             ? { ...item, quantity: item.quantity + 1 }
//             : item
//         )
//       );
//     } else {
//       setCart([...cart, { ...product, quantity: 1 }]);
//     }
//     alert(`${product.name} added to cart!`);
//   };

//   // Compare functionality
//   const toggleCompare = (productId) => {
//     if (compareList.includes(productId)) {
//       setCompareList(compareList.filter((id) => id !== productId));
//     } else {
//       if (compareList.length >= 4) {
//         alert("You can compare up to 4 products at once.");
//         return;
//       }
//       setCompareList([...compareList, productId]);
//     }
//   };

//   // Enquiry modal
//   const openEnquiryModal = (product) => {
//     setEnquiryModal({ open: true, product });
//   };

//   const closeEnquiryModal = () => {
//     setEnquiryModal({ open: false, product: null });
//   };

//   const handleEnquirySubmit = (e) => {
//     e.preventDefault();
//     const formData = new FormData(e.target);
//     const enquiryData = {
//       name: formData.get("name"),
//       email: formData.get("email"),
//       phone: formData.get("phone"),
//       product: enquiryModal.product.name,
//       message: formData.get("message"),
//     };
//     console.log("Enquiry submitted:", enquiryData);
//     alert("Thank you for your enquiry! We will contact you soon.");
//     closeEnquiryModal();
//   };

//   // Handle Enquiry Now with WhatsApp and Call options
//   const handleEnquiryNow = (product) => {
//     const whatsappMessage = `
// *Product Enquiry - Blue Sky Energy*
// ----------------------------------
// *Product:* ${product.name}
// *Price:* ₹${product.price.toLocaleString()}
// *Category:* ${product.category}

// Hi, I'm interested in this product and would like more information about:
// • Pricing and offers
// • Technical specifications
// • Installation process
// • Warranty details
// • Availability

// Please provide me with complete details. Thank you!
//     `.trim();

//     const encodedMessage = encodeURIComponent(whatsappMessage);
//     const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    
//     // Open WhatsApp in new tab
//     window.open(whatsappUrl, '_blank');
//   };

//   // FREE DEMO HANDLER
//   const handleFreeDemo = (product) => {
//     setDemoModal({
//       open: true,
//       product: product
//     });
//   };

//   const handleCloseDemoModal = () => {
//     setDemoModal({
//       open: false,
//       product: null
//     });
//   };

//   const handleSubmitDemo = async (formData) => {
//     try {
//       // Save to localStorage as backup
//       const demoId = `demo_${Date.now()}`;
//       localStorage.setItem(demoId, JSON.stringify({
//         ...formData,
//         submittedAt: new Date().toISOString(),
//         source: 'products_page_free_demo'
//       }));

//       // Send to backend API
//       const response = await axios.post(`${API_BASE_URL}/free-demo`, formData);
      
//       if (response.data.success) {
//         console.log('Demo request saved to database:', response.data.data);
//       }
      
//       return Promise.resolve();
//     } catch (error) {
//       console.error('Error saving demo request:', error);
//       // Still resolve even if backend fails (data saved to localStorage)
//       return Promise.resolve();
//     }
//   };

//   // View product details
//   const viewProductDetails = (productId) => {
//     navigate(`/product/${productId}`);
//   };

//   // Remove from cart
//   const removeFromCart = (productId) => {
//     setCart(cart.filter((item) => item.id !== productId));
//   };

//   // Update cart quantity
//   const updateCartQuantity = (productId, newQuantity) => {
//     if (newQuantity < 1) {
//       removeFromCart(productId);
//       return;
//     }
//     setCart(
//       cart.map((item) =>
//         item.id === productId ? { ...item, quantity: newQuantity } : item
//       )
//     );
//   };

//   // Calculate cart total
//   const cartTotal = cart.reduce(
//     (total, item) => total + item.price * item.quantity,
//     0
//   );

//   // Calculate savings
//   const cartSavings = cart.reduce(
//     (total, item) => total + (item.originalPrice - item.price) * item.quantity,
//     0
//   );

//   // State for cart sidebar
//   const [cartOpen, setCartOpen] = useState(false);

//   const toggleCart = () => {
//     setCartOpen(!cartOpen);
//   };

//   // Handle compare button
//   const handleCompareClick = () => {
//     if (compareList.length > 0) {
//       setShowCompareModal(true);
//     } else {
//       alert("Please add products to compare first.");
//     }
//   };

//   // Clear filters
//   const clearFilters = () => {
//     setSelectedCategory("all");
//     setPriceRange([0, 500000]);
//     setSearchQuery("");
//     setSortBy("featured");
//   };

//   const toggleMobileMenu = () => {
//     setMobileMenuOpen(!mobileMenuOpen);
//   };

//   // Button styles
//   const enquiryBtnStyle = {
//     backgroundColor: "#25D366",
//     color: "white",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//   };

//   // FREE DEMO BUTTON STYLE
//   const freeDemoBtnStyle = {
//     backgroundColor: "#447793",
//     color: "white",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//     gridColumn: "span 2",
//     marginTop: "8px"
//   };

//   // Responsive Styles - Blue Theme
//   const styles = {
//     container: {
//       fontFamily: "Cambria, serif",
//       backgroundColor: "#ffffff",
//       minHeight: "100vh",
//       overflowX: "hidden",
//       width: "100%",
//     },

//     // Header - Blue Theme with Mobile Menu
//     header: {
//       backgroundColor: "white",
//       color: "#123249",
//       padding: "15px 5%",
//       position: "sticky",
//       top: 0,
//       zIndex: 1000,
//       boxShadow: "0 2px 10px rgba(6, 18, 33, 0.1)",
//       borderBottom: "3px solid #447793",
//     },
//     headerContent: {
//       maxWidth: "1400px",
//       margin: "0 auto",
//       display: "flex",
//       flexDirection: "row",
//       alignItems: "center",
//       justifyContent: "space-between",
//       gap: "15px",
//       position: "relative",
//     },
//     logoContainer: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },
//     logo: {
//       fontSize: "1.5rem",
//       fontWeight: "800",
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//       color: "#123249",
//       cursor: "pointer",
//     },
//     desktopNav: {
//       display: "flex",
//       alignItems: "center",
//       gap: "20px",
//       marginLeft: "20px",
//     },
//     desktopNavLink: {
//       color: "#123249",
//       textDecoration: "none",
//       fontSize: "0.95rem",
//       fontWeight: "600",
//       transition: "color 0.3s",
//     },
//     searchContainer: {
//       width: "100%",
//       maxWidth: "500px",
//       position: "relative",
//       flex: "1",
//     },
//     searchInput: {
//       width: "100%",
//       padding: "12px 45px 12px 20px",
//       borderRadius: "25px",
//       border: "2px solid #447793",
//       fontSize: "1rem",
//       backgroundColor: "white",
//       color: "#123249",
//     },
//     searchIcon: {
//       position: "absolute",
//       right: "15px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       color: "#447793",
//     },
//     suggestionsBox: {
//       position: "absolute",
//       top: "100%",
//       left: 0,
//       right: 0,
//       backgroundColor: "white",
//       borderRadius: "10px",
//       boxShadow: "0 5px 15px rgba(6, 18, 33, 0.1)",
//       marginTop: "5px",
//       zIndex: 1000,
//       maxHeight: "300px",
//       overflowY: "auto",
//       border: "1px solid #447793",
//     },
//     suggestionItem: {
//       padding: "10px 15px",
//       borderBottom: "1px solid #DDE8ED",
//       cursor: "pointer",
//       color: "#123249",
//     },
//     headerActions: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//       flexWrap: "wrap",
//       justifyContent: "flex-end",
//     },
//     actionButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "8px 16px",
//       borderRadius: "25px",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "all 0.3s",
//       fontSize: "0.9rem",
//     },
//     actionCount: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       borderRadius: "50%",
//       width: "20px",
//       height: "20px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "0.8rem",
//       marginLeft: "5px",
//     },
//     menuButton: {
//       display: "none",
//       background: "none",
//       border: "none",
//       cursor: "pointer",
//       padding: "8px",
//       color: "#123249",
//     },
    
//     // Mobile Menu
//     mobileMenuOverlay: {
//       position: "fixed",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: "rgba(6, 18, 33, 0.5)",
//       zIndex: 1001,
//       display: mobileMenuOpen ? "block" : "none",
//     },
//     mobileMenu: {
//       position: "fixed",
//       top: 0,
//       right: mobileMenuOpen ? "0" : "-100%",
//       width: "280px",
//       height: "100vh",
//       backgroundColor: "white",
//       boxShadow: "-5px 0 25px rgba(6, 18, 33, 0.15)",
//       zIndex: 1002,
//       transition: "right 0.3s ease",
//       display: "flex",
//       flexDirection: "column",
//       overflowY: "auto",
//     },
//     mobileMenuHeader: {
//       padding: "20px",
//       borderBottom: "1px solid #DDE8ED",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     mobileMenuTitle: {
//       fontSize: "1.2rem",
//       fontWeight: "700",
//       color: "#123249",
//       margin: 0,
//     },
//     mobileMenuClose: {
//       background: "none",
//       border: "none",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       color: "#123249",
//     },
//     mobileMenuNav: {
//       padding: "20px",
//       display: "flex",
//       flexDirection: "column",
//       gap: "15px",
//     },
//     mobileNavSection: {
//       marginBottom: "15px",
//     },
//     mobileNavSectionTitle: {
//       fontSize: "0.9rem",
//       fontWeight: "600",
//       color: "#2D5A74",
//       marginBottom: "10px",
//       textTransform: "uppercase",
//       letterSpacing: "0.5px",
//     },
//     mobileNavLink: {
//       display: "block",
//       padding: "12px 0",
//       color: "#123249",
//       textDecoration: "none",
//       fontSize: "1rem",
//       fontWeight: "500",
//       borderBottom: "1px solid #DDE8ED",
//       transition: "color 0.3s",
//     },

//     // Featured Products Slideshow - Blue Theme
//     featuredSection: {
//       padding: "30px 5%",
//       backgroundColor: "#DDE8ED",
//     },
//     featuredContainer: {
//       maxWidth: "1400px",
//       margin: "0 auto",
//       position: "relative",
//     },
//     featuredTitle: {
//       fontSize: "1.8rem",
//       fontWeight: "700",
//       color: "#123249",
//       textAlign: "center",
//       marginBottom: "20px",
//     },
//     slideshowContainer: {
//       width: "100%",
//       height: "300px",
//       borderRadius: "15px",
//       overflow: "hidden",
//       position: "relative",
//       boxShadow: "0 10px 30px rgba(6, 18, 33, 0.1)",
//     },
//     slide: {
//       width: "100%",
//       height: "100%",
//       position: "absolute",
//       top: 0,
//       left: 0,
//       opacity: 0,
//       transition: "opacity 1s ease-in-out",
//       display: "flex",
//       alignItems: "center",
//       padding: "0 30px",
//     },
//     slideContent: {
//       maxWidth: "100%",
//       color: "white",
//     },
//     slideTitle: {
//       fontSize: "1.8rem",
//       fontWeight: "800",
//       marginBottom: "10px",
//       textShadow: "2px 2px 4px rgba(6, 18, 33, 0.3)",
//     },
//     slideDescription: {
//       fontSize: "1rem",
//       marginBottom: "20px",
//       opacity: 0.9,
//     },
//     slideCTA: {
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "10px 25px",
//       fontSize: "1rem",
//       fontWeight: "bold",
//       border: "none",
//       borderRadius: "25px",
//       cursor: "pointer",
//       transition: "all 0.3s",
//     },
//     slideIndicator: {
//       position: "absolute",
//       bottom: "15px",
//       left: "50%",
//       transform: "translateX(-50%)",
//       display: "flex",
//       gap: "8px",
//     },
//     indicatorDot: {
//       width: "10px",
//       height: "10px",
//       borderRadius: "50%",
//       backgroundColor: "rgba(255,255,255,0.5)",
//       cursor: "pointer",
//       transition: "all 0.3s",
//     },
//     indicatorDotActive: {
//       backgroundColor: "#447793",
//       transform: "scale(1.2)",
//     },

//     // Best Selling Products - Auto Scroll - Blue Theme
//     bestSellingSection: {
//       padding: "40px 5%",
//       backgroundColor: "white",
//       position: "relative",
//       overflow: "hidden",
//     },
//     bestSellingTitle: {
//       fontSize: "1.8rem",
//       fontWeight: "700",
//       color: "#123249",
//       marginBottom: "20px",
//       textAlign: "center",
//     },
//     bestSellingContainer: {
//       width: "100%",
//       overflow: "hidden",
//       position: "relative",
//     },
//     bestSellingScroll: {
//       display: "flex",
//       gap: "15px",
//       padding: "15px 5px",
//       animation: "scroll 40s linear infinite",
//     },
//     bestSellingCard: {
//       minWidth: "250px",
//       backgroundColor: "white",
//       borderRadius: "12px",
//       overflow: "hidden",
//       boxShadow: "0 5px 15px rgba(6, 18, 33, 0.08)",
//       transition: "all 0.3s ease",
//       border: "1px solid #DDE8ED",
//       flexShrink: 0,
//       position: "relative",
//     },
//     bestSellingBadge: {
//       position: "absolute",
//       top: "10px",
//       left: "10px",
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "4px 12px",
//       borderRadius: "20px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//       zIndex: 2,
//     },
//     bestSellingImage: {
//       width: "100%",
//       height: "150px",
//       backgroundColor: "#DDE8ED",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "2rem",
//       color: "#123249",
//       overflow: "hidden",
//       transition: "transform 0.3s ease",
//     },
//     bestSellingImageHover: {
//       transform: "scale(1.1)",
//     },
//     bestSellingContent: {
//       padding: "15px",
//     },
//     bestSellingName: {
//       fontSize: "1.1rem",
//       fontWeight: "700",
//       color: "#123249",
//       marginBottom: "8px",
//       height: "40px",
//       overflow: "hidden",
//     },
//     bestSellingPriceContainer: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       marginBottom: "10px",
//       flexWrap: "wrap",
//     },
//     bestSellingPrice: {
//       fontSize: "1.5rem",
//       fontWeight: "800",
//       color: "#123249",
//       display: "flex",
//       alignItems: "center",
//     },
//     priceSymbol: {
//       fontSize: "1.2rem",
//       marginRight: "5px",
//       fontWeight: "700",
//     },
//     bestSellingOriginalPrice: {
//       fontSize: "0.9rem",
//       color: "#2D5A74",
//       textDecoration: "line-through",
//     },
//     bestSellingDiscount: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "2px 8px",
//       borderRadius: "10px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//     },
//     bestSellingRating: {
//       display: "flex",
//       alignItems: "center",
//       gap: "5px",
//       marginBottom: "10px",
//       fontSize: "0.9rem",
//       color: "#447793",
//     },
//     bestSellingActions: {
//       display: "flex",
//       gap: "8px",
//       flexDirection: "column",
//     },
//     cardActionButton: {
//       width: "100%",
//       padding: "8px",
//       borderRadius: "6px",
//       border: "none",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "all 0.3s",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       gap: "6px",
//       fontSize: "0.85rem",
//     },
//     enquiryBtn: {
//       backgroundColor: "#25D366",
//       color: "white",
//     },
//     callBtn: {
//       backgroundColor: "#2D5A74",
//       color: "white",
//     },
//     viewDetailsBtn: {
//       backgroundColor: "#447793",
//       color: "white",
//       gridColumn: "span 2",
//     },
//     freeDemoBtn: {
//       backgroundColor: "#447793",
//       color: "white",
//       gridColumn: "span 2",
//     },

//     // Category Navigation - Horizontal Row - Blue Theme
//     categoryNavSection: {
//       padding: "20px 5%",
//       backgroundColor: "white",
//       borderBottom: "1px solid #DDE8ED",
//     },
//     categoryNavContainer: {
//       maxWidth: "1400px",
//       margin: "0 auto",
//       overflowX: "auto",
//       paddingBottom: "10px",
//     },
//     categoryNavTitle: {
//       fontSize: "1.5rem",
//       fontWeight: "700",
//       color: "#123249",
//       marginBottom: "15px",
//       textAlign: "center",
//     },
//     categoryNavList: {
//       display: "flex",
//       gap: "10px",
//       padding: "10px 0",
//       minWidth: "fit-content",
//     },
//     categoryNavItem: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       padding: "12px 20px",
//       borderRadius: "10px",
//       cursor: "pointer",
//       transition: "all 0.3s",
//       border: "1px solid transparent",
//       textAlign: "center",
//       minWidth: "120px",
//       backgroundColor: "#DDE8ED",
//     },
//     categoryNavItemActive: {
//       backgroundColor: "#447793",
//       borderColor: "#447793",
//     },
//     categoryNavItemContent: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       gap: "8px",
//     },
//     categoryNavIcon: {
//       fontSize: "1.8rem",
//     },
//     categoryNavName: {
//       fontSize: "0.9rem",
//       fontWeight: "600",
//     },
//     categoryNavCount: {
//       backgroundColor: "white",
//       color: "#123249",
//       padding: "2px 6px",
//       borderRadius: "10px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//       marginTop: "5px",
//     },

//     // Category Section - Row Wise Display - Blue Theme
//     categorySection: {
//       padding: "40px 5%",
//       backgroundColor: "#ffffff",
//     },
//     categorySectionInner: {
//       maxWidth: "1400px",
//       margin: "0 auto",
//     },
//     categoryHeader: {
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       marginBottom: "25px",
//       paddingBottom: "15px",
//       borderBottom: "2px solid #447793",
//     },
//     categoryTitle: {
//       fontSize: "1.8rem",
//       fontWeight: "700",
//       color: "#123249",
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },
//     categoryDescription: {
//       fontSize: "1rem",
//       color: "#2D5A74",
//       marginTop: "5px",
//     },
//     viewAllButton: {
//       display: "flex",
//       alignItems: "center",
//       gap: "5px",
//       backgroundColor: "transparent",
//       color: "#447793",
//       border: "1px solid #447793",
//       padding: "8px 16px",
//       borderRadius: "20px",
//       fontWeight: "600",
//       cursor: "pointer",
//       transition: "all 0.3s",
//       fontSize: "0.9rem",
//     },
//     categoryProductsGrid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
//       gap: "20px",
//     },
//     categoryProductCard: {
//       backgroundColor: "white",
//       borderRadius: "12px",
//       overflow: "hidden",
//       boxShadow: "0 5px 15px rgba(6, 18, 33, 0.08)",
//       transition: "all 0.3s ease",
//       border: "1px solid #DDE8ED",
//       position: "relative",
//     },
//     categoryProductImage: {
//       width: "100%",
//       height: "180px",
//       backgroundColor: "#DDE8ED",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       color: "#123249",
//       fontSize: "2rem",
//       fontWeight: "600",
//       position: "relative",
//       overflow: "hidden",
//     },
//     productImageTag: {
//       width: "100%",
//       height: "100%",
//       objectFit: "cover",
//       transition: "transform 0.5s ease",
//     },
//     categoryProductBadge: {
//       position: "absolute",
//       top: "8px",
//       right: "8px",
//       backgroundColor: "#447793",
//       color: "white",
//       padding: "4px 8px",
//       borderRadius: "12px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//       zIndex: 2,
//     },
//     categoryProductContent: {
//       padding: "15px",
//     },
//     categoryProductName: {
//       fontSize: "1.1rem",
//       fontWeight: "700",
//       color: "#123249",
//       marginBottom: "6px",
//       height: "40px",
//       overflow: "hidden",
//     },
//     categoryProductDescription: {
//       color: "#2D5A74",
//       fontSize: "0.9rem",
//       marginBottom: "12px",
//       height: "35px",
//       overflow: "hidden",
//     },
//     categoryProductPrice: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//       marginBottom: "12px",
//       flexWrap: "wrap",
//     },
//     categoryCurrentPrice: {
//       fontSize: "1.3rem",
//       fontWeight: "800",
//       color: "#123249",
//       display: "flex",
//       alignItems: "center",
//     },
//     categoryPriceSymbol: {
//       fontSize: "1rem",
//       marginRight: "5px",
//     },
//     categoryOriginalPrice: {
//       fontSize: "0.9rem",
//       color: "#2D5A74",
//       textDecoration: "line-through",
//     },
//     categoryDiscountBadge: {
//       backgroundColor: "#DDE8ED",
//       color: "#123249",
//       padding: "2px 6px",
//       borderRadius: "4px",
//       fontSize: "0.7rem",
//       fontWeight: "600",
//     },
//     categoryProductRating: {
//       display: "flex",
//       alignItems: "center",
//       gap: "5px",
//       marginBottom: "12px",
//       fontSize: "0.9rem",
//       color: "#447793",
//     },
//     categoryProductActions: {
//       display: "grid",
//       gridTemplateColumns: "1fr 1fr",
//       gap: "8px",
//     },
//     categoryWishlistButton: {
//       position: "absolute",
//       top: "12px",
//       right: "12px",
//       backgroundColor: "white",
//       border: "none",
//       width: "35px",
//       height: "35px",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       boxShadow: "0 2px 5px rgba(6, 18, 33, 0.2)",
//       transition: "all 0.3s",
//       zIndex: 2,
//     },
//     categoryCompareButton: {
//       position: "absolute",
//       top: "57px",
//       right: "12px",
//       backgroundColor: "white",
//       border: "none",
//       width: "35px",
//       height: "35px",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       boxShadow: "0 2px 5px rgba(6, 18, 33, 0.2)",
//       transition: "all 0.3s",
//       zIndex: 2,
//     },

//     // Cart Sidebar - Blue Theme
//     cartSidebar: {
//       position: "fixed",
//       top: "0",
//       right: "-100%",
//       width: "100%",
//       maxWidth: "400px",
//       height: "100vh",
//       backgroundColor: "white",
//       boxShadow: "-5px 0 25px rgba(6, 18, 33, 0.15)",
//       zIndex: 1001,
//       transition: "right 0.3s ease",
//       display: "flex",
//       flexDirection: "column",
//     },
//     cartSidebarOpen: {
//       right: "0",
//     },
//     cartHeader: {
//       padding: "15px",
//       borderBottom: "1px solid #DDE8ED",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//     },
//     cartTitle: {
//       fontSize: "1.3rem",
//       fontWeight: "700",
//       color: "#123249",
//     },
//     cartClose: {
//       backgroundColor: "transparent",
//       border: "none",
//       fontSize: "1.5rem",
//       cursor: "pointer",
//       color: "#2D5A74",
//     },
//     cartItems: {
//       flex: 1,
//       overflowY: "auto",
//       padding: "15px",
//     },
//     cartItem: {
//       display: "flex",
//       gap: "12px",
//       padding: "12px 0",
//       borderBottom: "1px solid #DDE8ED",
//     },
//     cartItemImage: {
//       width: "60px",
//       height: "60px",
//       backgroundColor: "#DDE8ED",
//       borderRadius: "8px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "1.2rem",
//       color: "#123249",
//     },
//     cartItemContent: {
//       flex: 1,
//     },
//     cartItemName: {
//       fontWeight: "600",
//       marginBottom: "5px",
//       color: "#123249",
//       fontSize: "0.95rem",
//     },
//     cartItemPrice: {
//       color: "#447793",
//       fontWeight: "700",
//       marginBottom: "8px",
//       fontSize: "0.9rem",
//     },
//     cartItemActions: {
//       display: "flex",
//       alignItems: "center",
//       gap: "8px",
//     },
//     quantityButton: {
//       width: "25px",
//       height: "25px",
//       borderRadius: "50%",
//       border: "1px solid #DDE8ED",
//       backgroundColor: "white",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "0.8rem",
//       color: "#123249",
//     },
//     quantityInput: {
//       width: "35px",
//       textAlign: "center",
//       border: "1px solid #DDE8ED",
//       borderRadius: "5px",
//       padding: "4px",
//       fontSize: "0.9rem",
//       color: "#123249",
//     },
//     removeButton: {
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       padding: "4px 8px",
//       borderRadius: "5px",
//       cursor: "pointer",
//       fontSize: "0.75rem",
//     },
//     cartFooter: {
//       padding: "15px",
//       borderTop: "1px solid #DDE8ED",
//     },
//     cartTotal: {
//       display: "flex",
//       justifyContent: "space-between",
//       marginBottom: "8px",
//       fontWeight: "600",
//       fontSize: "1.1rem",
//       color: "#123249",
//     },
//     cartSavings: {
//       color: "#447793",
//       marginBottom: "15px",
//       fontSize: "0.85rem",
//     },
//     checkoutButton: {
//       width: "100%",
//       padding: "12px",
//       backgroundColor: "#447793",
//       color: "white",
//       border: "none",
//       borderRadius: "8px",
//       fontSize: "1rem",
//       fontWeight: "600",
//       cursor: "pointer",
//     },

//     // Chatbot Styles - Blue Theme
//     chatbotContainer: {
//       position: "fixed",
//       bottom: "15px",
//       right: "15px",
//       zIndex: 9999,
//       fontFamily: "Cambria, serif",
//     },
//     chatToggleBtn: {
//       position: "fixed",
//       bottom: "15px",
//       right: "15px",
//       width: "55px",
//       height: "55px",
//       borderRadius: "50%",
//       background: "linear-gradient(135deg, #447793, #2D5A74)",
//       color: "white",
//       border: "none",
//       fontSize: "22px",
//       cursor: "pointer",
//       boxShadow: "0 6px 20px rgba(68, 119, 147, 0.3)",
//       transition: "all 0.3s ease",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: "10000",
//       padding: "0",
//       animation: "pulse 2s infinite",
//     },
//     chatWindow: {
//       position: "fixed",
//       bottom: "80px",
//       right: "15px",
//       width: "calc(100vw - 40px)",
//       maxWidth: "380px",
//       height: "500px",
//       maxHeight: "65vh",
//       background: "white",
//       borderRadius: "16px",
//       boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
//       display: "flex",
//       flexDirection: "column",
//       overflow: "hidden",
//       zIndex: "9999",
//       transition: "all 0.3s ease",
//       opacity: 0,
//       visibility: "hidden",
//       transform: "translateY(20px)",
//       border: "1px solid #DDE8ED",
//     },
//     chatWindowOpen: {
//       opacity: "1",
//       visibility: "visible",
//       transform: "translateY(0)",
//     },
//     chatHeader: {
//       background: "linear-gradient(135deg, #447793, #2D5A74)",
//       color: "white",
//       padding: "14px",
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
//     },
//     headerInfo: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//     },
//     headerIcon: {
//       background: "rgba(255, 255, 255, 0.2)",
//       padding: "8px",
//       borderRadius: "50%",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       width: "35px",
//       height: "35px",
//       fontSize: "16px",
//     },
//     chatHeaderTitle: {
//       margin: "0",
//       fontSize: "14px",
//       fontWeight: "600",
//       lineHeight: "1.2",
//       color: "white",
//     },
//     chatHeaderSubtitle: {
//       margin: "0",
//       fontSize: "11px",
//       opacity: "0.9",
//       lineHeight: "1.2",
//       color: "#DDE8ED",
//     },
//     closeChatBtn: {
//       background: "none",
//       border: "none",
//       color: "white",
//       cursor: "pointer",
//       fontSize: "16px",
//       padding: "4px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       transition: "opacity 0.2s",
//     },
//     quickReplies: {
//       padding: "10px",
//       display: "flex",
//       flexWrap: "wrap",
//       gap: "6px",
//       background: "#DDE8ED",
//       borderBottom: "1px solid #DDE8ED",
//     },
//     replyBtn: {
//       background: "white",
//       border: "1px solid #447793",
//       color: "#123249",
//       padding: "6px 12px",
//       borderRadius: "15px",
//       fontSize: "12px",
//       cursor: "pointer",
//       transition: "all 0.2s ease",
//       whiteSpace: "nowrap",
//       fontWeight: "500",
//       fontFamily: "Cambria, serif",
//     },
//     chatMessages: {
//       flex: "1",
//       padding: "14px",
//       background: "#DDE8ED",
//       overflowY: "auto",
//       display: "flex",
//       flexDirection: "column",
//       gap: "10px",
//     },
//     message: {
//       maxWidth: "85%",
//       padding: "10px 14px",
//       borderRadius: "15px",
//       fontSize: "13px",
//       lineHeight: "1.5",
//       whiteSpace: "pre-line",
//       wordWrap: "break-word",
//       position: "relative",
//       animation: "fadeIn 0.3s ease",
//     },
//     botMessage: {
//       background: "white",
//       alignSelf: "flex-start",
//       borderBottomLeftRadius: "4px",
//       boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
//       color: "#123249",
//       border: "1px solid #DDE8ED",
//     },
//     userMessage: {
//       background: "linear-gradient(135deg, #447793, #2D5A74)",
//       color: "white",
//       alignSelf: "flex-end",
//       borderBottomRightRadius: "4px",
//     },
//     messageTime: {
//       fontSize: "10px",
//       marginTop: "5px",
//       display: "block",
//       opacity: "0.7",
//     },
//     chatInputArea: {
//       padding: "14px",
//       borderTop: "1px solid #DDE8ED",
//       background: "white",
//     },
//     inputWrapper: {
//       display: "flex",
//       gap: "8px",
//       marginBottom: "6px",
//     },
//     chatInput: {
//       flex: "1",
//       padding: "10px 14px",
//       border: "1px solid #DDE8ED",
//       borderRadius: "25px",
//       outline: "none",
//       fontSize: "13px",
//       fontFamily: "Cambria, serif",
//       transition: "border-color 0.2s",
//       color: "#123249",
//     },
//     sendBtn: {
//       background: "linear-gradient(135deg, #447793, #2D5A74)",
//       color: "white",
//       border: "none",
//       width: "40px",
//       height: "40px",
//       borderRadius: "50%",
//       cursor: "pointer",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       fontSize: "14px",
//       transition: "all 0.2s ease",
//       padding: "0",
//     },
//     footerText: {
//       textAlign: "center",
//       fontSize: "10px",
//       color: "#2D5A74",
//       margin: "0",
//     },

//     // Empty state - Blue Theme
//     emptyState: {
//       textAlign: "center",
//       padding: "60px 20px",
//       color: "#2D5A74",
//       backgroundColor: "white",
//       borderRadius: "15px",
//       margin: "20px 0",
//     },

//     // Footer - Blue Theme
//     footer: {
//       backgroundColor: "#123249",
//       color: "white",
//       padding: "40px 5%",
//       textAlign: "center",
//     },
//     footerContent: {
//       maxWidth: "1400px",
//       margin: "0 auto",
//     },
//     footerTitle: {
//       fontSize: "1.5rem",
//       fontWeight: "700",
//       marginBottom: "15px",
//       color: "white",
//     },
//     footerText: {
//       color: "#DDE8ED",
//       marginBottom: "25px",
//       maxWidth: "800px",
//       margin: "0 auto 25px",
//       fontSize: "0.95rem",
//     },
//     contactInfo: {
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       gap: "20px",
//       marginBottom: "25px",
//     },
//     contactItem: {
//       display: "flex",
//       alignItems: "center",
//       gap: "10px",
//       color: "#DDE8ED",
//     },

//     // Loading state - Blue Theme
//     loadingContainer: {
//       textAlign: "center",
//       padding: "40px 20px",
//       backgroundColor: "white",
//       borderRadius: "15px",
//       margin: "20px 0",
//       color: "#123249",
//     },

//     // Main Content Styles - Blue Theme
//     mainContent: {
//       padding: "20px 5%",
//       backgroundColor: "#ffffff",
//     },
//   };

//   // Responsive CSS Media Queries - Blue Theme
//   const responsiveCSS = `
//     /* Color Palette */
//     :root {
//       --color-deep-teal: #061221;
//       --color-dark-navy: #123249;
//       --color-midnight: #2D5A74;
//       --color-slate: #447793;
//       --color-frost: #DDE8ED;
//       --color-white: #ffffff;
//       --gradient-primary: linear-gradient(135deg, #447793 0%, #2D5A74 100%);
//       --gradient-hover: linear-gradient(135deg, #2D5A74 0%, #123249 100%);
//       --shadow-sm: 0 2px 15px rgba(6, 18, 33, 0.08);
//       --shadow-md: 0 4px 20px rgba(6, 18, 33, 0.12);
//       --shadow-lg: 0 10px 30px rgba(6, 18, 33, 0.15);
//     }

//     /* Responsive CSS for Products Page */
//     @media (max-width: 1024px) {
//       .desktop-nav {
//         display: none !important;
//       }
      
//       .menu-button {
//         display: flex !important;
//       }
      
//       .header-content {
//         flex-wrap: wrap !important;
//       }
      
//       .search-container {
//         order: 3 !important;
//         max-width: 100% !important;
//         width: 100% !important;
//         margin-top: 10px !important;
//       }
//     }

//     @media (max-width: 768px) {
//       .header-content {
//         flex-direction: row !important;
//         flex-wrap: wrap !important;
//         gap: 10px !important;
//       }
      
//       .logo-container {
//         width: auto !important;
//       }
      
//       .logo {
//         font-size: 1.2rem !important;
//       }
      
//       .header-actions {
//         width: auto !important;
//         justify-content: flex-end !important;
//         gap: 8px !important;
//       }
      
//       .action-button {
//         padding: 6px 12px !important;
//         font-size: 0.8rem !important;
//       }
      
//       .action-button span:not(.action-count) {
//         display: none !important;
//       }
      
//       .action-button svg {
//         margin-right: 0 !important;
//       }
      
//       .featured-title {
//         font-size: 1.6rem !important;
//       }
      
//       .slideshow-container {
//         height: 250px !important;
//       }
      
//       .slide {
//         padding: 0 20px !important;
//       }
      
//       .slide-title {
//         font-size: 1.5rem !important;
//       }
      
//       .slide-description {
//         font-size: 0.9rem !important;
//       }
      
//       .best-selling-title {
//         font-size: 1.6rem !important;
//       }
      
//       .best-selling-card {
//         min-width: 220px !important;
//       }
      
//       .best-selling-image {
//         height: 130px !important;
//       }
      
//       .best-selling-name {
//         font-size: 1rem !important;
//         height: 35px !important;
//       }
      
//       .best-selling-price {
//         font-size: 1.3rem !important;
//       }
      
//       .category-nav-title {
//         font-size: 1.3rem !important;
//       }
      
//       .category-nav-item {
//         min-width: 100px !important;
//         padding: 10px 15px !important;
//       }
      
//       .category-nav-icon {
//         font-size: 1.5rem !important;
//       }
      
//       .category-nav-name {
//         font-size: 0.8rem !important;
//       }
      
//       .category-title {
//         font-size: 1.5rem !important;
//       }
      
//       .category-header {
//         flex-direction: column !important;
//         align-items: flex-start !important;
//         gap: 10px !important;
//       }
      
//       .view-all-button {
//         align-self: flex-start !important;
//       }
      
//       .category-products-grid {
//         grid-template-columns: 1fr !important;
//         gap: 15px !important;
//       }
      
//       .category-product-card {
//         margin-bottom: 10px !important;
//       }
      
//       .category-product-image {
//         height: 160px !important;
//       }
      
//       .category-product-name {
//         font-size: 1rem !important;
//         height: 35px !important;
//       }
      
//       .category-current-price {
//         font-size: 1.2rem !important;
//       }
      
//       .category-product-actions {
//         grid-template-columns: 1fr !important;
//         gap: 6px !important;
//       }
      
//       .card-action-button {
//         padding: 8px !important;
//         font-size: 0.8rem !important;
//       }
      
//       .chat-window {
//         width: calc(100vw - 30px) !important;
//         right: 15px !important;
//         bottom: 75px !important;
//         height: 450px !important;
//       }
      
//       .cart-sidebar {
//         width: 100% !important;
//         max-width: 100% !important;
//       }
      
//       .cart-item {
//         flex-direction: column !important;
//         align-items: flex-start !important;
//       }
      
//       .cart-item-image {
//         width: 50px !important;
//         height: 50px !important;
//       }
      
//       .footer-title {
//         font-size: 1.3rem !important;
//       }
//     }
    
//     @media (min-width: 481px) and (max-width: 768px) {
//       .category-products-grid {
//         grid-template-columns: repeat(2, 1fr) !important;
//       }
      
//       .category-nav-list {
//         justify-content: center !important;
//       }
      
//       .best-selling-card {
//         min-width: 200px !important;
//       }
//     }
    
//     @media (min-width: 769px) {
//       .category-products-grid {
//         grid-template-columns: repeat(3, 1fr) !important;
//       }
      
//       .best-selling-card {
//         min-width: 280px !important;
//       }
//     }
    
//     @media (min-width: 992px) {
//       .category-products-grid {
//         grid-template-columns: repeat(4, 1fr) !important;
//       }
      
//       .best-selling-card {
//         min-width: 300px !important;
//       }
//     }
    
//     @media (min-width: 1200px) {
//       .category-products-grid {
//         grid-template-columns: repeat(4, 1fr) !important;
//         gap: 25px !important;
//       }
      
//       .best-selling-card {
//         min-width: 320px !important;
//       }
//     }
    
//     @media (max-width: 480px) {
//       .header-actions {
//         gap: 6px !important;
//       }
      
//       .action-button {
//         padding: 6px 10px !important;
//         font-size: 0.75rem !important;
//       }
      
//       .slideshow-container {
//         height: 220px !important;
//       }
      
//       .slide-title {
//         font-size: 1.3rem !important;
//       }
      
//       .slide-description {
//         font-size: 0.85rem !important;
//       }
      
//       .slide-cta {
//         padding: 8px 20px !important;
//         font-size: 0.9rem !important;
//       }
      
//       .best-selling-card {
//         min-width: 180px !important;
//       }
      
//       .best-selling-name {
//         font-size: 0.9rem !important;
//       }
      
//       .best-selling-price {
//         font-size: 1.1rem !important;
//       }
      
//       .category-nav-item {
//         min-width: 90px !important;
//         padding: 8px 12px !important;
//       }
      
//       .category-nav-icon {
//         font-size: 1.3rem !important;
//       }
      
//       .category-nav-name {
//         font-size: 0.75rem !important;
//       }
      
//       .category-product-actions {
//         grid-template-columns: 1fr !important;
//       }
      
//       .chat-window {
//         width: calc(100vw - 20px) !important;
//         right: 10px !important;
//         left: 10px !important;
//         height: 400px !important;
//         max-height: 60vh !important;
//       }
      
//       .chat-toggle-btn {
//         width: 50px !important;
//         height: 50px !important;
//         font-size: 20px !important;
//       }
      
//       .quick-replies {
//         padding: 8px !important;
//         gap: 4px !important;
//       }
      
//       .reply-btn {
//         font-size: 11px !important;
//         padding: 4px 8px !important;
//       }
      
//       .chat-messages {
//         padding: 10px !important;
//       }
      
//       .message {
//         font-size: 12px !important;
//         padding: 8px 12px !important;
//       }
      
//       .cart-sidebar {
//         max-width: 100% !important;
//       }
      
//       .mobile-menu {
//         width: 100% !important;
//       }
//     }
    
//     /* Animation for best selling scroll */
//     @keyframes scroll {
//       0% { transform: translateX(0); }
//       100% { transform: translateX(calc(-265px * ${bestSellingProducts.length})); }
//     }
    
//     @keyframes fadeIn {
//       from { opacity: 0; transform: translateY(10px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
    
//     @keyframes pulse {
//       0% { transform: scale(1); }
//       50% { transform: scale(1.05); }
//       100% { transform: scale(1); }
//     }
    
//     /* Cart overlay for mobile */
//     .cart-overlay {
//       position: fixed;
//       top: 0;
//       left: 0;
//       right: 0;
//       bottom: 0;
//       background: rgba(6, 18, 33, 0.5);
//       z-index: 1000;
//       display: none;
//     }
    
//     @media (max-width: 768px) {
//       .cart-sidebar-open + .cart-overlay {
//         display: block !important;
//       }
//     }
    
//     /* Fix for mobile viewport */
//     @media (max-width: 768px) {
//       .container {
//         overflow-x: hidden !important;
//       }
      
//       .category-nav-section {
//         padding: 15px !important;
//       }
      
//       .category-section {
//         padding: 30px 15px !important;
//       }
      
//       .best-selling-section {
//         padding: 30px 15px !important;
//       }
      
//       .featured-section {
//         padding: 25px 15px !important;
//       }
      
//       .main-content {
//         padding: 20px 15px !important;
//       }
//     }
    
//     /* Custom scrollbar for category navigation */
//     .category-nav-container::-webkit-scrollbar {
//       height: 6px;
//     }
    
//     .category-nav-container::-webkit-scrollbar-track {
//       background: #DDE8ED;
//       border-radius: 10px;
//     }
    
//     .category-nav-container::-webkit-scrollbar-thumb {
//       background: #447793;
//       border-radius: 10px;
//     }
    
//     .category-nav-container::-webkit-scrollbar-thumb:hover {
//       background: #2D5A74;
//     }
    
//     /* Hover effects */
//     .action-button:hover {
//       background-color: #2D5A74 !important;
//     }
    
//     .view-all-button:hover {
//       background-color: #447793 !important;
//       color: white !important;
//     }
    
//     .category-product-card:hover {
//       transform: translateY(-5px) !important;
//       box-shadow: 0 10px 25px rgba(68, 119, 147, 0.15) !important;
//     }
    
//     .category-product-card:hover .category-product-image img {
//       transform: scale(1.1) !important;
//     }
    
//     .best-selling-card:hover {
//       transform: translateY(-5px) !important;
//       box-shadow: 0 10px 25px rgba(68, 119, 147, 0.15) !important;
//     }
    
//     .best-selling-card:hover .best-selling-image {
//       transform: scale(1.1) !important;
//     }
    
//     .desktop-nav-link:hover {
//       color: #447793 !important;
//     }
    
//     .mobile-nav-link:hover {
//       color: #447793 !important;
//       padding-left: 10px !important;
//     }
//   `;

//   return (
//     <div style={styles.container}>
//       {/* Responsive CSS Styles */}
//       <style>{responsiveCSS}</style>

//       {/* FREE DEMO MODAL */}
//       <FreeDemoModal
//         isOpen={demoModal.open}
//         onClose={handleCloseDemoModal}
//         product={demoModal.product}
//         onSubmit={handleSubmitDemo}
//       />

//       {/* Cart Overlay for Mobile */}
//       {cartOpen && <div className="cart-overlay" onClick={toggleCart}></div>}

//       {/* Mobile Menu Overlay */}
//       <div 
//         className="mobile-menu-overlay" 
//         style={styles.mobileMenuOverlay}
//         onClick={toggleMobileMenu}
//       ></div>

//       {/* Mobile Menu */}
//       <div style={styles.mobileMenu} className="mobile-menu">
//         <div style={styles.mobileMenuHeader}>
//           <h3 style={styles.mobileMenuTitle}>Menu</h3>
//           <button 
//             style={styles.mobileMenuClose}
//             onClick={toggleMobileMenu}
//           >
//             ×
//           </button>
//         </div>
//         <div style={styles.mobileMenuNav}>
//           <div style={styles.mobileNavSection}>
//             <div style={styles.mobileNavSectionTitle}>Solutions</div>
//             <a href="/commercial" style={styles.mobileNavLink}>Commercial</a>
//             <a href="/residential" style={styles.mobileNavLink}>Residential</a>
//             <a href="/industrial" style={styles.mobileNavLink}>Industrial</a>
//           </div>
          
//           <div style={styles.mobileNavSection}>
//             <div style={styles.mobileNavSectionTitle}>Company</div>
//             <a href="/about" style={styles.mobileNavLink}>About Us</a>
//             <a href="/contact" style={styles.mobileNavLink}>Contact Us</a>
//             <a href="/products" style={styles.mobileNavLink}>Products</a>
//             <a href="/more" style={styles.mobileNavLink}>More</a>
//           </div>
          
//           <div style={styles.mobileNavSection}>
//             <div style={styles.mobileNavSectionTitle}>Account</div>
//             <a href="/login" style={styles.mobileNavLink}>Login</a>
//             <a href="/register" style={styles.mobileNavLink}>Register</a>
//           </div>
//         </div>
//       </div>

//       {/* Header - Blue Theme with Mobile Menu */}
//       <header style={styles.header}>
//         <div style={styles.headerContent} className="header-content">
//           <div style={styles.logoContainer} className="logo-container">
//             <div
//               style={styles.logo}
//               className="logo"
//               onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
//             >
//               <span style={{ color: "#447793" }}>☀️</span>
//               Blue Sky Energy
//             </div>

            
//           </div>

//           <div style={styles.headerActions} className="header-actions">
//             <button
//               style={styles.actionButton}
//               className="action-button"
//               onClick={() => alert(`Wishlist has ${wishlist.length} items`)}
//             >
//               <HeartIcon filled={wishlist.length > 0} />
//               <span>Wishlist</span>
//               {wishlist.length > 0 && (
//                 <span style={styles.actionCount} className="action-count">
//                   {wishlist.length}
//                 </span>
//               )}
//             </button>
//             <button
//               style={styles.actionButton}
//               className="action-button"
//               onClick={handleCompareClick}
//             >
//               <CompareIcon />
//               <span>Compare</span>
//               {compareList.length > 0 && (
//                 <span style={styles.actionCount} className="action-count">
//                   {compareList.length}
//                 </span>
//               )}
//             </button>
//             <button
//               style={styles.actionButton}
//               className="action-button"
//               onClick={toggleCart}
//             >
//               <ShoppingCartIcon />
//               <span>Cart</span>
//               {cart.length > 0 && (
//                 <span style={styles.actionCount} className="action-count">
//                   {cart.length}
//                 </span>
//               )}
//             </button>
//             <button
//               style={styles.menuButton}
//               className="menu-button"
//               onClick={toggleMobileMenu}
//             >
//               <MenuIcon />
//             </button>
//           </div>
//         </div>

//         {/* Search Bar - Below Header on Mobile */}
//         <div style={styles.searchContainer} className="search-container">
//           <input
//             type="text"
//             placeholder="Search solar products..."
//             style={styles.searchInput}
//             className="search-input"
//             value={searchQuery}
//             onChange={handleSearch}
//             onFocus={(e) => e.target.style.borderColor = "#2D5A74"}
//             onBlur={(e) => e.target.style.borderColor = "#447793"}
//           />
//           <div style={styles.searchIcon} className="search-icon">
//             <SearchIcon />
//           </div>

//           {/* Search Suggestions */}
//           {searchSuggestions.length > 0 && (
//             <div style={styles.suggestionsBox} className="suggestions-box">
//               {searchSuggestions.map((product) => (
//                 <div
//                   key={product.id}
//                   style={styles.suggestionItem}
//                   className="suggestion-item"
//                   onClick={() => {
//                     setSearchQuery(product.name);
//                     setSearchSuggestions([]);
//                   }}
//                   onMouseEnter={(e) =>
//                     (e.currentTarget.style.backgroundColor = "#DDE8ED")
//                   }
//                   onMouseLeave={(e) =>
//                     (e.currentTarget.style.backgroundColor = "white")
//                   }
//                 >
//                   {product.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </header>

//       {/* Featured Products Slideshow - Blue Theme */}
//       <section style={styles.featuredSection} className="featured-section">
//         <div style={styles.featuredContainer} className="featured-container">
//           <h2 style={styles.featuredTitle} className="featured-title">
//             Featured Solar Products
//           </h2>
//           <div style={styles.slideshowContainer} className="slideshow-container">
//             {featuredSlides.map((slide, index) => (
//               <div
//                 key={slide.id}
//                 style={{
//                   ...styles.slide,
//                   backgroundColor: slide.bgColor,
//                   opacity: index === currentSlide ? 1 : 0,
//                 }}
//                 className="slide"
//               >
//                 <div style={styles.slideContent} className="slide-content">
//                   <h3 style={styles.slideTitle} className="slide-title">
//                     {slide.title}
//                   </h3>
//                   <p style={styles.slideDescription} className="slide-description">
//                     {slide.description}
//                   </p>
//                   <button
//                     style={styles.slideCTA}
//                     className="slide-cta"
//                     onClick={() => viewProductDetails(slide.productId)}
//                     onMouseEnter={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#2D5A74")
//                     }
//                     onMouseLeave={(e) =>
//                       (e.currentTarget.style.backgroundColor = "#447793")
//                     }
//                   >
//                     {slide.cta}
//                   </button>
//                 </div>
//               </div>
//             ))}

//             <div style={styles.slideIndicator} className="slide-indicator">
//               {featuredSlides.map((_, index) => (
//                 <div
//                   key={index}
//                   style={{
//                     ...styles.indicatorDot,
//                     ...(index === currentSlide
//                       ? styles.indicatorDotActive
//                       : {}),
//                   }}
//                   className="indicator-dot"
//                   onClick={() => setCurrentSlide(index)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Best Selling Products - Auto Scroll - Blue Theme */}
//       <section style={styles.bestSellingSection} className="best-selling-section">
//         <h2 style={styles.bestSellingTitle} className="best-selling-title">
//           Best Selling Products
//         </h2>
        
//         {loading ? (
//           <div style={styles.loadingContainer} className="loading-container">
//             <p>Loading best selling products...</p>
//           </div>
//         ) : error ? (
//           <div style={{textAlign: 'center', padding: '30px', color: '#447793'}}>
//             <p>{error}</p>
//             <button 
//               onClick={fetchProductsFromDatabase}
//               style={{
//                 marginTop: '15px',
//                 padding: '8px 16px',
//                 backgroundColor: '#447793',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '5px',
//                 cursor: 'pointer',
//                 fontSize: '0.9rem',
//               }}
//               onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
//               onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
//             >
//               Retry Connection
//             </button>
//           </div>
//         ) : (
//           <div style={styles.bestSellingContainer} className="best-selling-container">
//             <div style={styles.bestSellingScroll} className="best-selling-scroll" ref={bestSellingRef}>
//               {/* Duplicate products for seamless scrolling */}
//               {[
//                 ...bestSellingProducts,
//                 ...bestSellingProducts,
//                 ...bestSellingProducts,
//               ].map((product, index) => (
//                 <div
//                   key={`${product.id}-${index}`}
//                   style={styles.bestSellingCard}
//                   className="best-selling-card"
//                 >
//                   <div style={styles.bestSellingBadge} className="best-selling-badge">Best Seller</div>

//                   <div style={styles.bestSellingImage} className="best-selling-image">
//                     <img 
//                       src={product.image} 
//                       alt={product.name}
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                         transition: 'transform 0.5s ease',
//                       }}
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop";
//                       }}
//                     />
//                   </div>

//                   <div style={styles.bestSellingContent} className="best-selling-content">
//                     <h3 style={styles.bestSellingName} className="best-selling-name">
//                       {product.name}
//                     </h3>

//                     <div style={styles.bestSellingPriceContainer} className="best-selling-price-container">
//                       <div style={styles.bestSellingPrice} className="best-selling-price">
//                         <span style={styles.priceSymbol} className="price-symbol">₹</span>
//                         {product.price.toLocaleString()}
//                       </div>
//                       {product.originalPrice > product.price && (
//                         <>
//                           <span style={styles.bestSellingOriginalPrice} className="best-selling-original-price">
//                             ₹{product.originalPrice.toLocaleString()}
//                           </span>
//                           <span style={styles.bestSellingDiscount} className="best-selling-discount">
//                             Save ₹
//                             {(
//                               product.originalPrice - product.price
//                             ).toLocaleString()}
//                           </span>
//                         </>
//                       )}
//                     </div>

//                     <div style={styles.bestSellingRating} className="best-selling-rating">
//                       <span style={{color: "#447793"}}>
//                         {"★".repeat(Math.floor(product.rating))}
//                         {"☆".repeat(5 - Math.floor(product.rating))}
//                       </span>
//                       <span>({product.reviews})</span>
//                     </div>

//                     <div style={styles.bestSellingActions} className="best-selling-actions">
//                       <button
//                         style={{
//                           ...styles.cardActionButton,
//                           ...styles.enquiryBtn,
//                         }}
//                         className="card-action-button enquiry-btn"
//                         onClick={() => handleEnquiryNow(product)}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#128C7E")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#25D366")
//                         }
//                       >
//                         <WhatsAppIcon /> Enquire Now
//                       </button>
//                       <button
//                         style={{
//                           ...styles.cardActionButton,
//                           ...styles.viewDetailsBtn,
//                         }}
//                         className="card-action-button view-details-btn"
//                         onClick={() => viewProductDetails(product.id)}
//                         onMouseEnter={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#2D5A74")
//                         }
//                         onMouseLeave={(e) =>
//                           (e.currentTarget.style.backgroundColor = "#447793")
//                         }
//                       >
//                         👁️ View Details
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </section>

//       {/* Category Navigation - Horizontal Row - Blue Theme */}
//       <section style={styles.categoryNavSection} className="category-nav-section">
//         <div style={styles.categoryNavContainer} className="category-nav-container">
//           <h3 style={styles.categoryNavTitle} className="category-nav-title">Browse by Category</h3>
//           <div style={styles.categoryNavList} className="category-nav-list">
//             <div
//               style={{
//                 ...styles.categoryNavItem,
//                 ...(selectedCategory === "all" && styles.categoryNavItemActive),
//               }}
//               className="category-nav-item"
//               onClick={() => setSelectedCategory("all")}
//             >
//               <div style={styles.categoryNavItemContent} className="category-nav-item-content">
//                 <span style={styles.categoryNavIcon} className="category-nav-icon">📦</span>
//                 <span style={{
//                   ...styles.categoryNavName,
//                   ...(selectedCategory === "all" && { color: "white" })
//                 }} className="category-nav-name">All Products</span>
//               </div>
//               <span style={{
//                 ...styles.categoryNavCount,
//                 ...(selectedCategory === "all" && { backgroundColor: "#DDE8ED", color: "#123249" })
//               }} className="category-nav-count">{allProducts.length}</span>
//             </div>
            
//             {categories.map((category) => (
//               <div
//                 key={category.id}
//                 style={{
//                   ...styles.categoryNavItem,
//                   ...(selectedCategory === category.id && styles.categoryNavItemActive),
//                 }}
//                 className="category-nav-item"
//                 onClick={() => handleCategorySelect(category.id)}
//               >
//                 <div style={styles.categoryNavItemContent} className="category-nav-item-content">
//                   <span style={styles.categoryNavIcon} className="category-nav-icon">{category.icon}</span>
//                   <span style={{
//                     ...styles.categoryNavName,
//                     ...(selectedCategory === category.id && { color: "white" })
//                   }} className="category-nav-name">{category.name}</span>
//                 </div>
//                 <span style={{
//                   ...styles.categoryNavCount,
//                   ...(selectedCategory === category.id && { backgroundColor: "#DDE8ED", color: "#123249" })
//                 }} className="category-nav-count">{category.count}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Main Content - Category-wise Sections - Blue Theme */}
//       <main style={styles.mainContent} className="main-content">
//         {loading ? (
//           <div style={styles.loadingContainer} className="loading-container">
//             <p>Loading products from database...</p>
//           </div>
//         ) : error ? (
//           <div style={{textAlign: 'center', padding: '50px 20px', color: '#447793'}}>
//             <p>{error}</p>
//             <button 
//               onClick={fetchProductsFromDatabase}
//               style={{
//                 marginTop: '15px',
//                 padding: '8px 16px',
//                 backgroundColor: '#447793',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '5px',
//                 cursor: 'pointer',
//                 fontSize: '0.9rem',
//               }}
//               onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
//               onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
//             >
//               Retry Connection
//             </button>
//           </div>
//         ) : selectedCategory === "all" ? (
//           // Show all categories row-wise
//           categories.map((category) => (
//             category.products.length > 0 && (
//               <section key={category.id} id={`category-${category.id}`} style={styles.categorySection} className="category-section">
//                 <div style={styles.categorySectionInner} className="category-section-inner">
//                   <div style={styles.categoryHeader} className="category-header">
//                     <div>
//                       <h3 style={styles.categoryTitle} className="category-title">
//                         <span>{category.icon}</span>
//                         {category.name}
//                       </h3>
//                       <p style={styles.categoryDescription} className="category-description">
//                         {category.description} • {category.count} products
//                       </p>
//                     </div>
//                     <button
//                       style={styles.viewAllButton}
//                       className="view-all-button"
//                       onClick={() => handleCategorySelect(category.id)}
//                     >
//                       View All <ChevronRight />
//                     </button>
//                   </div>

//                   <div style={styles.categoryProductsGrid} className="category-products-grid">
//                     {category.products.slice(0, 4).map((product) => (
//                       <div
//                         key={product.id}
//                         style={styles.categoryProductCard}
//                         className="category-product-card"
//                       >
//                         {/* Badge */}
//                         {product.tags && product.tags.includes("best-seller") && (
//                           <div style={styles.categoryProductBadge} className="category-product-badge">Best Seller</div>
//                         )}
//                         {product.tags && product.tags.includes("new-arrival") && (
//                           <div
//                             style={{
//                               ...styles.categoryProductBadge,
//                               backgroundColor: "#2D5A74",
//                             }}
//                             className="category-product-badge new-badge"
//                           >
//                             New
//                           </div>
//                         )}

//                         {/* Wishlist Button */}
//                         <button
//                           style={styles.categoryWishlistButton}
//                           className="category-wishlist-button"
//                           onClick={() => toggleWishlist(product.id)}
//                         >
//                           <HeartIcon filled={wishlist.includes(product.id)} />
//                         </button>

//                         {/* Compare Button */}
//                         <button
//                           style={styles.categoryCompareButton}
//                           className="category-compare-button"
//                           onClick={() => toggleCompare(product.id)}
//                         >
//                           <CompareIcon />
//                         </button>

//                         {/* Product Image */}
//                         <div style={styles.categoryProductImage} className="category-product-image">
//                           <img 
//                             src={product.image} 
//                             alt={product.name}
//                             style={styles.productImageTag}
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop";
//                             }}
//                           />
//                         </div>

//                         {/* Product Content */}
//                         <div style={styles.categoryProductContent} className="category-product-content">
//                           <h3 style={styles.categoryProductName} className="category-product-name">{product.name}</h3>
//                           <p style={styles.categoryProductDescription} className="category-product-description">
//                             {product.description}
//                           </p>

//                           <div style={styles.categoryProductPrice} className="category-product-price">
//                             <span style={styles.categoryCurrentPrice} className="category-current-price">
//                               <span style={styles.categoryPriceSymbol} className="category-price-symbol">₹</span>
//                               {product.price.toLocaleString()}
//                             </span>
//                             {product.originalPrice > product.price && (
//                               <>
//                                 <span style={styles.categoryOriginalPrice} className="category-original-price">
//                                   ₹{product.originalPrice.toLocaleString()}
//                                 </span>
//                                 <span style={styles.categoryDiscountBadge} className="category-discount-badge">
//                                   Save ₹
//                                   {(
//                                     product.originalPrice - product.price
//                                   ).toLocaleString()}
//                                 </span>
//                               </>
//                             )}
//                           </div>

//                           <div style={styles.categoryProductRating} className="category-product-rating">
//                             <div style={{color: "#447793"}}>
//                               {"★".repeat(Math.floor(product.rating))}
//                               {"☆".repeat(5 - Math.floor(product.rating))}
//                             </div>
//                             <span style={{color: "#2D5A74"}}>
//                               ({product.reviews} reviews)
//                             </span>
//                           </div>

//                           <div style={styles.categoryProductActions} className="category-product-actions">
//                             <button
//                               style={{
//                                 ...styles.cardActionButton,
//                                 ...styles.enquiryBtn,
//                               }}
//                               className="card-action-button enquiry-btn"
//                               onClick={() => handleEnquiryNow(product)}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#128C7E")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#25D366")
//                               }
//                             >
//                               <WhatsAppIcon /> Enquire
//                             </button>
//                             <button
//                               style={{
//                                 ...styles.cardActionButton,
//                                 ...styles.callBtn,
//                               }}
//                               className="card-action-button call-btn"
//                               onClick={() => addToCart(product)}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#123249")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#2D5A74")
//                               }
//                             >
//                               🛒 Add to Cart
//                             </button>
//                             {/* FREE DEMO BUTTON */}
//                             <button
//                               style={{
//                                 ...styles.cardActionButton,
//                                 ...styles.freeDemoBtn,
//                               }}
//                               className="card-action-button free-demo-btn"
//                               onClick={() => handleFreeDemo(product)}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#2D5A74")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#447793")
//                               }
//                             >
//                               📅 Free Demo
//                             </button>
//                             {/* View Details Button */}
//                             <button
//                               style={{
//                                 ...styles.cardActionButton,
//                                 ...styles.viewDetailsBtn,
//                               }}
//                               className="card-action-button view-details-btn"
//                               onClick={() => viewProductDetails(product.id)}
//                               onMouseEnter={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#2D5A74")
//                               }
//                               onMouseLeave={(e) =>
//                                 (e.currentTarget.style.backgroundColor = "#447793")
//                               }
//                             >
//                               👁️ View Details
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </section>
//             )
//           ))
//         ) : (
//           // Show selected category products only
//           (() => {
//             const category = categories.find(cat => cat.id === selectedCategory);
//             return category && category.products.length > 0 ? (
//               <section id={`category-${category.id}`} style={styles.categorySection} className="category-section">
//                 <div style={styles.categorySectionInner} className="category-section-inner">
//                   <div style={styles.categoryHeader} className="category-header">
//                     <div>
//                       <h3 style={styles.categoryTitle} className="category-title">
//                         <span>{category.icon}</span>
//                         {category.name}
//                       </h3>
//                       <p style={styles.categoryDescription} className="category-description">
//                         {category.description} • {category.count} products
//                       </p>
//                     </div>
//                     <button
//                       style={styles.viewAllButton}
//                       className="view-all-button"
//                       onClick={() => setSelectedCategory("all")}
//                     >
//                       Back to All Categories <ChevronRight />
//                     </button>
//                   </div>

//                   {filteredProducts.length === 0 ? (
//                     <div style={styles.emptyState} className="empty-state">
//                       <div
//                         style={{
//                           fontSize: "3rem",
//                           color: "#447793",
//                           marginBottom: "15px",
//                         }}
//                       >
//                         ☀️
//                       </div>
//                       <h3>No products found</h3>
//                       <p>Try adjusting your filters or search terms</p>
//                     </div>
//                   ) : (
//                     <div style={styles.categoryProductsGrid} className="category-products-grid">
//                       {filteredProducts.map((product) => (
//                         <div
//                           key={product.id}
//                           style={styles.categoryProductCard}
//                           className="category-product-card"
//                         >
//                           {/* Badge */}
//                           {product.tags && product.tags.includes("best-seller") && (
//                             <div style={styles.categoryProductBadge} className="category-product-badge">Best Seller</div>
//                           )}
//                           {product.tags && product.tags.includes("new-arrival") && (
//                             <div
//                               style={{
//                                 ...styles.categoryProductBadge,
//                                 backgroundColor: "#2D5A74",
//                               }}
//                               className="category-product-badge new-badge"
//                             >
//                               New
//                             </div>
//                           )}

//                           {/* Wishlist Button */}
//                           <button
//                             style={styles.categoryWishlistButton}
//                             className="category-wishlist-button"
//                             onClick={() => toggleWishlist(product.id)}
//                           >
//                             <HeartIcon filled={wishlist.includes(product.id)} />
//                           </button>

//                           {/* Compare Button */}
//                           <button
//                             style={styles.categoryCompareButton}
//                             className="category-compare-button"
//                             onClick={() => toggleCompare(product.id)}
//                           >
//                             <CompareIcon />
//                           </button>

//                           {/* Product Image */}
//                           <div style={styles.categoryProductImage} className="category-product-image">
//                             <img 
//                               src={product.image} 
//                               alt={product.name}
//                               style={styles.productImageTag}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop";
//                               }}
//                             />
//                           </div>

//                           {/* Product Content */}
//                           <div style={styles.categoryProductContent} className="category-product-content">
//                             <h3 style={styles.categoryProductName} className="category-product-name">{product.name}</h3>
//                             <p style={styles.categoryProductDescription} className="category-product-description">
//                               {product.description}
//                             </p>

//                             <div style={styles.categoryProductPrice} className="category-product-price">
//                               <span style={styles.categoryCurrentPrice} className="category-current-price">
//                                 <span style={styles.categoryPriceSymbol} className="category-price-symbol">₹</span>
//                                 {product.price.toLocaleString()}
//                               </span>
//                               {product.originalPrice > product.price && (
//                                 <>
//                                   <span style={styles.categoryOriginalPrice} className="category-original-price">
//                                     ₹{product.originalPrice.toLocaleString()}
//                                   </span>
//                                   <span style={styles.categoryDiscountBadge} className="category-discount-badge">
//                                     Save ₹
//                                     {(
//                                       product.originalPrice - product.price
//                                     ).toLocaleString()}
//                                   </span>
//                                 </>
//                               )}
//                             </div>

//                             <div style={styles.categoryProductRating} className="category-product-rating">
//                               <div style={{color: "#447793"}}>
//                                 {"★".repeat(Math.floor(product.rating))}
//                                 {"☆".repeat(5 - Math.floor(product.rating))}
//                               </div>
//                               <span style={{color: "#2D5A74"}}>
//                                 ({product.reviews} reviews)
//                               </span>
//                             </div>

//                             <div style={styles.categoryProductActions} className="category-product-actions">
//                               <button
//                                 style={{
//                                   ...styles.cardActionButton,
//                                   ...styles.enquiryBtn,
//                                 }}
//                                 className="card-action-button enquiry-btn"
//                                 onClick={() => handleEnquiryNow(product)}
//                                 onMouseEnter={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#128C7E")
//                                 }
//                                 onMouseLeave={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#25D366")
//                                 }
//                               >
//                                 <WhatsAppIcon /> Enquire
//                               </button>
//                               <button
//                                 style={{
//                                   ...styles.cardActionButton,
//                                   ...styles.callBtn,
//                                 }}
//                                 className="card-action-button call-btn"
//                                 onClick={() => addToCart(product)}
//                                 onMouseEnter={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#123249")
//                                 }
//                                 onMouseLeave={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#2D5A74")
//                                 }
//                               >
//                                 🛒 Add to Cart
//                               </button>
//                               {/* FREE DEMO BUTTON */}
//                               <button
//                                 style={{
//                                   ...styles.cardActionButton,
//                                   ...styles.freeDemoBtn,
//                                 }}
//                                 className="card-action-button free-demo-btn"
//                                 onClick={() => handleFreeDemo(product)}
//                                 onMouseEnter={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#2D5A74")
//                                 }
//                                 onMouseLeave={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#447793")
//                                 }
//                               >
//                                 📅 Free Demo
//                               </button>
//                               {/* View Details Button */}
//                               <button
//                                 style={{
//                                   ...styles.cardActionButton,
//                                   ...styles.viewDetailsBtn,
//                                 }}
//                                 className="card-action-button view-details-btn"
//                                 onClick={() => viewProductDetails(product.id)}
//                                 onMouseEnter={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#2D5A74")
//                                 }
//                                 onMouseLeave={(e) =>
//                                   (e.currentTarget.style.backgroundColor = "#447793")
//                                 }
//                               >
//                                 👁️ View Details
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </section>
//             ) : (
//               <div style={styles.emptyState} className="empty-state">
//                 <div
//                   style={{
//                     fontSize: "3rem",
//                     color: "#447793",
//                     marginBottom: "15px",
//                   }}
//                 >
//                   ☀️
//                 </div>
//                 <h3>No products found in this category</h3>
//                 <p>Try selecting a different category</p>
//               </div>
//             );
//           })()
//         )}
//       </main>

//       {/* Cart Sidebar - Blue Theme */}
//       <div
//         style={{
//           ...styles.cartSidebar,
//           ...(cartOpen && styles.cartSidebarOpen),
//         }}
//         className="cart-sidebar"
//       >
//         <div style={styles.cartHeader} className="cart-header">
//           <h3 style={styles.cartTitle} className="cart-title">Shopping Cart ({cart.length})</h3>
//           <button style={styles.cartClose} className="cart-close" onClick={toggleCart}>
//             ×
//           </button>
//         </div>

//         <div style={styles.cartItems} className="cart-items">
//           {cart.length === 0 ? (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: "40px 20px",
//                 color: "#2D5A74",
//               }}
//             >
//               <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🛒</div>
//               <h4>Your cart is empty</h4>
//               <p>Add some products to get started</p>
//             </div>
//           ) : (
//             cart.map((item) => (
//               <div key={item.id} style={styles.cartItem} className="cart-item">
//                 <div style={styles.cartItemImage} className="cart-item-image">
//                   <img 
//                     src={item.image} 
//                     alt={item.name}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',
//                       borderRadius: '8px',
//                     }}
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop";
//                     }}
//                   />
//                 </div>
//                 <div style={styles.cartItemContent} className="cart-item-content">
//                   <div style={styles.cartItemName} className="cart-item-name">{item.name}</div>
//                   <div style={styles.cartItemPrice} className="cart-item-price">
//                     ₹{item.price.toLocaleString()}
//                   </div>
//                   <div style={styles.cartItemActions} className="cart-item-actions">
//                     <button
//                       style={styles.quantityButton}
//                       className="quantity-button"
//                       onClick={() =>
//                         updateCartQuantity(item.id, item.quantity - 1)
//                       }
//                     >
//                       -
//                     </button>
//                     <input
//                       type="number"
//                       value={item.quantity}
//                       onChange={(e) =>
//                         updateCartQuantity(item.id, parseInt(e.target.value))
//                       }
//                       style={styles.quantityInput}
//                       className="quantity-input"
//                       min="1"
//                     />
//                     <button
//                       style={styles.quantityButton}
//                       className="quantity-button"
//                       onClick={() =>
//                         updateCartQuantity(item.id, item.quantity + 1)
//                       }
//                     >
//                       +
//                     </button>
//                     <button
//                       style={styles.removeButton}
//                       className="remove-button"
//                       onClick={() => removeFromCart(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         {cart.length > 0 && (
//           <div style={styles.cartFooter} className="cart-footer">
//             <div style={styles.cartTotal} className="cart-total">
//               <span>Subtotal:</span>
//               <span>₹{cartTotal.toLocaleString()}</span>
//             </div>
//             {cartSavings > 0 && (
//               <div style={styles.cartSavings} className="cart-savings">
//                 You save: ₹{cartSavings.toLocaleString()}
//               </div>
//             )}
//             <button
//               style={styles.checkoutButton}
//               className="checkout-button"
//               onClick={() => {
//                 alert("Proceeding to checkout!");
//                 setCartOpen(false);
//               }}
//               onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
//               onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
//             >
//               Proceed to Checkout
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Chatbot Component - Blue Theme */}
//       <div style={styles.chatbotContainer}>
//         {/* Chat Toggle Button */}
//         <button
//           style={{
//             ...styles.chatToggleBtn,
//             animation: chatbotHover
//               ? "pulse 0.5s infinite"
//               : "pulse 2s infinite",
//           }}
//           className="chat-toggle-btn"
//           onClick={() => setIsChatOpen(!isChatOpen)}
//           onMouseEnter={() => setChatbotHover(true)}
//           onMouseLeave={() => setChatbotHover(false)}
//         >
//           💬
//         </button>

//         {/* Chat Window */}
//         <div style={{
//           ...styles.chatWindow,
//           ...(isChatOpen && styles.chatWindowOpen)
//         }} className="chat-window">
//           {/* Chat Header */}
//           <div style={styles.chatHeader} className="chat-header">
//             <div style={styles.headerInfo} className="header-info">
//               <div style={styles.headerIcon} className="header-icon">☀️</div>
//               <div>
//                 <h3 style={styles.chatHeaderTitle} className="chat-header-title">Blue Sky Energy</h3>
//                 <p style={styles.chatHeaderSubtitle} className="chat-header-subtitle">
//                   Product Expert & Pricing
//                 </p>
//               </div>
//             </div>
//             <button
//               style={styles.closeChatBtn}
//               className="close-chat-btn"
//               onClick={() => setIsChatOpen(false)}
//             >
//               <XIcon />
//             </button>
//           </div>

//           {/* Quick Replies */}
//           {quickReplies.length > 0 && (
//             <div style={styles.quickReplies} className="quick-replies">
//               {quickReplies.map((option, index) => (
//                 <button
//                   key={index}
//                   style={styles.replyBtn}
//                   className="reply-btn"
//                   onClick={() => handleQuickReply(option)}
//                   onMouseEnter={(e) => {
//                     e.target.style.background = "#447793";
//                     e.target.style.color = "white";
//                     e.target.style.transform = "translateY(-1px)";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.background = "white";
//                     e.target.style.color = "#123249";
//                     e.target.style.transform = "none";
//                   }}
//                 >
//                   {option}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* Chat Messages */}
//           <div style={styles.chatMessages} className="chat-messages">
//             {chatMessages.map((msg) => (
//               <div
//                 key={msg.id}
//                 style={{
//                   ...styles.message,
//                   ...(msg.sender === "bot"
//                     ? styles.botMessage
//                     : styles.userMessage),
//                 }}
//                 className="message"
//               >
//                 {msg.text}
//                 <span style={styles.messageTime} className="message-time">{msg.time}</span>
//               </div>
//             ))}
//           </div>

//           {/* Chat Input */}
//           <div style={styles.chatInputArea} className="chat-input-area">
//             <div style={styles.inputWrapper} className="input-wrapper">
//               <input
//                 type="text"
//                 value={chatInput}
//                 onChange={(e) => setChatInput(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 placeholder="Ask about products, prices, installation..."
//                 style={styles.chatInput}
//                 className="chat-input"
//                 onFocus={(e) => (e.target.style.borderColor = "#447793")}
//                 onBlur={(e) => (e.target.style.borderColor = "#DDE8ED")}
//               />
//               <button
//                 style={styles.sendBtn}
//                 className="send-btn"
//                 onClick={handleChatSend}
//                 onMouseEnter={(e) => {
//                   e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
//                   e.target.style.transform = "scale(1.05)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
//                   e.target.style.transform = "scale(1)";
//                 }}
//               >
//                 📤
//               </button>
//             </div>
//             <p style={styles.footerText} className="footer-text">
//               {allProducts.length}+ Products • 25-year Warranties • 1000+ Happy Customers
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Footer - Blue Theme */}
//       <footer style={styles.footer}>
//         <div style={styles.footerContent} className="footer-content">
//           <h2 style={styles.footerTitle} className="footer-title">Blue Sky Energy</h2>
//           <p style={styles.footerText} className="footer-text">
//             Your trusted partner for solar energy solutions. We provide
//             high-quality solar products with expert installation and lifetime
//             support. Go green with Blue Sky Energy.
//           </p>

//           <div style={styles.contactInfo} className="contact-info">
//             <div style={styles.contactItem} className="contact-item">
//               <PhoneIcon />
//               <span>+91 80879 32436</span>
//             </div>
//             <div style={styles.contactItem} className="contact-item">
//               <span>📧</span>
//               <span>info@blueskyenergy.in</span>
//             </div>
//           </div>

//           <p style={{ ...styles.footerText, fontSize: "0.85rem" }}>
//             © 2024 Blue Sky Energy. All rights reserved.
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Products;
































// pages/Products.js
import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";

// SVG Icons as components (keep all your existing icon components here)
const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </svg>
);

const PhoneIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const ShoppingCartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const HeartIcon = ({ filled = false }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill={filled ? "#447793" : "none"}
    stroke={filled ? "#447793" : "currentColor"}
    strokeWidth="2"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const CompareIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const MenuIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const ChatIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

const XIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.473-.149-.673.149-.2.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.126.553 4.121 1.519 5.863L.049 23.95l6.136-1.452A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.844 0-3.589-.498-5.09-1.374l-.365-.216-3.643.864.868-3.6-.228-.38A9.96 9.96 0 0 1 2 12C2 6.486 6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z"/>
  </svg>
);

const CallIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

// FREE DEMO MODAL COMPONENT
const FreeDemoModal = ({ isOpen, onClose, product, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    preferredDate: '',
    preferredTime: 'morning',
    message: '',
    productName: product?.name || '',
    productId: product?.id || '',
    status: 'pending'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (product) {
      setFormData(prev => ({
        ...prev,
        productName: product.name,
        productId: product.id
      }));
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await onSubmit(formData);
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        onClose();
        setFormData({
          name: '',
          phone: '',
          email: '',
          address: '',
          city: '',
          pincode: '',
          preferredDate: '',
          preferredTime: 'morning',
          message: '',
          productName: product?.name || '',
          productId: product?.id || '',
          status: 'pending'
        });
      }, 3000);
    } catch (error) {
      console.error('Error submitting demo request:', error);
      alert('Failed to submit demo request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 18, 33, 0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px',
      fontFamily: 'Cambria, serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '15px',
        maxWidth: '600px',
        width: '100%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 40px rgba(6, 18, 33, 0.3)',
        position: 'relative',
        animation: 'fadeIn 0.3s ease'
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #447793, #2D5A74)',
          color: 'white',
          padding: '20px 25px',
          borderRadius: '15px 15px 0 0',
          position: 'sticky',
          top: 0,
          zIndex: 10
        }}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              color: 'white',
              fontSize: '20px',
              cursor: 'pointer',
              width: '35px',
              height: '35px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
          <h2 style={{ margin: 0, fontSize: '1.8rem' }}>📞 Free Demo & Site Visit</h2>
          <p style={{ margin: '5px 0 0', opacity: 0.9 }}>
            {product?.name ? `For: ${product.name}` : 'Solar Product Consultation'}
          </p>
        </div>

        {submitted ? (
          <div style={{
            padding: '40px',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '4rem',
              marginBottom: '20px',
              color: '#447793'
            }}>✅</div>
            <h3 style={{ color: '#123249', marginBottom: '15px' }}>
              Demo Request Submitted Successfully!
            </h3>
            <p style={{ color: '#2D5A74', marginBottom: '20px' }}>
              Thank you for your interest! Our solar expert will contact you within 24 hours to schedule your free demo and site visit.
            </p>
            <p style={{ color: '#447793', fontWeight: 'bold' }}>
              A confirmation has been sent to your email.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ padding: '25px' }}>
            {product && (
              <div style={{
                backgroundColor: '#DDE8ED',
                padding: '15px',
                borderRadius: '10px',
                marginBottom: '20px',
                border: '1px solid #447793'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '1.5rem' }}>☀️</span>
                  <div>
                    <strong style={{ color: '#123249' }}>{product.name}</strong>
                    <p style={{ margin: '5px 0 0', color: '#2D5A74', fontSize: '0.9rem' }}>
                      Price: ₹{product.price?.toLocaleString()}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px' }}>
              Personal Information
            </h4>
            
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '1px solid #DDE8ED',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  outline: 'none',
                  transition: 'border-color 0.3s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#447793'}
                onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                placeholder="Enter your full name"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  Phone Number *
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                  placeholder="10-digit mobile number"
                  pattern="[0-9]{10}"
                  maxLength="10"
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                  placeholder="your@email.com"
                />
              </div>
            </div>

            <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px', marginTop: '25px' }}>
              Location for Site Visit
            </h4>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                Address *
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '1px solid #DDE8ED',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  outline: 'none',
                  minHeight: '80px',
                  resize: 'vertical'
                }}
                onFocus={(e) => e.target.style.borderColor = '#447793'}
                onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                placeholder="Enter your complete address for site visit"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  City *
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                  placeholder="e.g., Mumbai"
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  Pincode *
                </label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                  placeholder="400001"
                  pattern="[0-9]{6}"
                  maxLength="6"
                />
              </div>
            </div>

            <h4 style={{ color: '#123249', marginBottom: '15px', borderBottom: '2px solid #447793', paddingBottom: '8px', marginTop: '25px' }}>
              Preferred Schedule
            </h4>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  Preferred Date *
                </label>
                <input
                  type="date"
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                  required
                  min={new Date().toISOString().split('T')[0]}
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                  Preferred Time *
                </label>
                <select
                  name="preferredTime"
                  value={formData.preferredTime}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 15px',
                    border: '1px solid #DDE8ED',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    outline: 'none',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#447793'}
                  onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                >
                  <option value="morning">Morning (9 AM - 12 PM)</option>
                  <option value="afternoon">Afternoon (12 PM - 3 PM)</option>
                  <option value="evening">Evening (3 PM - 6 PM)</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: '25px' }}>
              <label style={{ display: 'block', marginBottom: '5px', color: '#123249', fontWeight: '600' }}>
                Additional Message / Requirements
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                style={{
                  width: '100%',
                  padding: '12px 15px',
                  border: '1px solid #DDE8ED',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  outline: 'none',
                  minHeight: '80px',
                  resize: 'vertical'
                }}
                onFocus={(e) => e.target.style.borderColor = '#447793'}
                onBlur={(e) => e.target.style.borderColor = '#DDE8ED'}
                placeholder="Tell us about any specific requirements or questions..."
              />
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={onClose}
                style={{
                  padding: '12px 25px',
                  backgroundColor: 'transparent',
                  color: '#123249',
                  border: '1px solid #447793',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#DDE8ED';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                style={{
                  padding: '12px 30px',
                  backgroundColor: isSubmitting ? '#2D5A74' : '#447793',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: isSubmitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  if (!isSubmitting) e.target.style.backgroundColor = '#2D5A74';
                }}
                onMouseLeave={(e) => {
                  if (!isSubmitting) e.target.style.backgroundColor = '#447793';
                }}
              >
                {isSubmitting ? 'Submitting...' : '📅 Book Free Demo'}
              </button>
            </div>

            <p style={{ marginTop: '20px', fontSize: '0.85rem', color: '#2D5A74', textAlign: 'center' }}>
              Our solar expert will contact you within 24 hours to confirm your appointment.
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

const Products = () => {
  const navigate = useNavigate();
  
  // State management
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [enquiryModal, setEnquiryModal] = useState({
    open: false,
    product: null,
  });
  const [cart, setCart] = useState([]);
  const [compareList, setCompareList] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 500000]);
  const [sortBy, setSortBy] = useState("featured");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [bestSellingScrollPos, setBestSellingScrollPos] = useState(0);
  const [showCompareModal, setShowCompareModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Database states
  const [dbProducts, setDbProducts] = useState([]);
  const [dbBestSellers, setDbBestSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Chatbot states
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [leadCaptured, setLeadCaptured] = useState(false);
  const [awaitingLeadInfo, setAwaitingLeadInfo] = useState(false);
  const [leadStep, setLeadStep] = useState(0);
  const [userData, setUserData] = useState({
    name: "",
    phone: "",
    email: "",
    productInterest: "",
  });
  const [messageCount, setMessageCount] = useState(0);
  const [quickReplies, setQuickReplies] = useState([]);
  const [chatbotHover, setChatbotHover] = useState(false);

  // FREE DEMO MODAL STATE
  const [demoModal, setDemoModal] = useState({
    open: false,
    product: null
  });

  const scrollContainerRef = useRef(null);
  const bestSellingRef = useRef(null);
  const autoScrollRef = useRef(null);

  // API base URL
  const API_BASE_URL = 'http://localhost:5000/api';
  const WHATSAPP_NUMBER = '8421377814';

  // Static fallback data with proper image paths
  const productData = [
    {
      id: 1,
      name: "SolarSquare Flexi 300W Panel",
      description: "High-efficiency monocrystalline solar panel with 21.5% efficiency",
      fullDescription: "Premium monocrystalline solar panel with anti-reflective coating, superior low-light performance, and 25-year linear power output warranty. Perfect for residential rooftops.",
      price: 18500,
      originalPrice: 21500,
      category: "panels",
      categoryDisplay: "Solar Panels",
      rating: 4.8,
      reviews: 124,
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
      features: ["300W Output", "25-year Warranty", "Weather Resistant", "Easy Installation", "High Efficiency"],
      tags: ["best-seller", "new-arrival", "featured"],
      stock: 25,
      isFeatured: true,
      specs: { power: "300W", efficiency: "21.5%", warranty: "25 years", dimensions: "175×100 cm", weight: "18 kg" },
    },
    {
      id: 2,
      name: "SmartSolar Inverter 5kW",
      description: "Hybrid solar inverter with battery backup",
      fullDescription: "Smart hybrid inverter with WiFi monitoring, pure sine wave output, and seamless grid-tie functionality. Includes mobile app for real-time monitoring.",
      price: 45000,
      originalPrice: 52000,
      category: "inverters",
      categoryDisplay: "Inverters",
      rating: 4.7,
      reviews: 89,
      image: "https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop",
      features: ["5kW Capacity", "WiFi Monitoring", "Pure Sine Wave", "MPPT Technology", "Grid-tie"],
      tags: ["featured", "smart-device", "best-seller"],
      stock: 12,
      isFeatured: true,
      specs: { capacity: "5kW", type: "Hybrid", efficiency: "97%", warranty: "5 years", connectivity: "WiFi" },
    },
    {
      id: 3,
      name: "Solar Battery 150Ah",
      description: "Deep cycle solar battery with 10-year warranty",
      fullDescription: "Maintenance-free deep cycle battery designed specifically for solar applications with excellent cycle life and fast charging capability.",
      price: 16500,
      originalPrice: 19000,
      category: "batteries",
      categoryDisplay: "Batteries",
      rating: 4.6,
      reviews: 156,
      image: "https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=400&h=400&fit=crop",
      features: ["150Ah Capacity", "Maintenance Free", "Deep Cycle", "10-year Warranty", "Fast Charge"],
      tags: ["value-pack", "long-life", "featured", "best-seller"],
      stock: 18,
      isFeatured: true,
      specs: { capacity: "150Ah", voltage: "12V", warranty: "10 years", cycles: "2000+", type: "Deep Cycle" },
    },
    {
      id: 4,
      name: "Solar Charge Controller 60A",
      description: "MPPT charge controller with LCD display",
      fullDescription: "Advanced MPPT charge controller with temperature compensation and multiple charging modes for optimal battery health.",
      price: 8500,
      originalPrice: 10500,
      category: "controllers",
      categoryDisplay: "Controllers",
      rating: 4.5,
      reviews: 67,
      image: "https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop",
      features: ["60A Capacity", "MPPT Technology", "LCD Display", "Temperature Compensation", "USB Port"],
      tags: ["energy-efficient"],
      stock: 30,
      isFeatured: false,
      specs: { capacity: "60A", type: "MPPT", efficiency: "98%", warranty: "3 years", display: "LCD" },
    },
    {
      id: 5,
      name: "Solar Mounting Structure Kit",
      description: "Complete roof mounting kit for solar panels",
      fullDescription: "Galvanized steel mounting structure with all necessary hardware for easy installation on various roof types.",
      price: 12000,
      originalPrice: 14500,
      category: "accessories",
      categoryDisplay: "Accessories",
      rating: 4.4,
      reviews: 42,
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
      features: ["Galvanized Steel", "All Hardware Included", "Adjustable Angle", "Wind Resistant", "Corrosion Proof"],
      tags: ["installation", "hardware"],
      stock: 22,
      isFeatured: false,
      specs: { material: "Galvanized Steel", capacity: "20 panels", warranty: "10 years", adjustment: "0-45 degrees", corrosion: "Rust Proof" },
    },
    {
      id: 6,
      name: "Solar Home Kit 3kW",
      description: "Complete solar solution for homes",
      fullDescription: "Complete package including 6 solar panels, inverter, batteries, and all accessories for 3kW system with professional installation.",
      price: 185000,
      originalPrice: 225000,
      category: "kits",
      categoryDisplay: "Complete Kits",
      rating: 4.9,
      reviews: 203,
      image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop",
      features: ["Complete System", "Professional Installation", "5-year Warranty", "24/7 Support", "WiFi Monitoring"],
      tags: ["complete-solution", "best-seller", "installation-included", "featured"],
      stock: 8,
      isFeatured: true,
      specs: { capacity: "3kW", components: "Full System", warranty: "5 years", installation: "Included", monitoring: "WiFi" },
    },
    {
      id: 7,
      name: "Solar Water Heater 100L",
      description: "Solar thermal water heating system",
      fullDescription: "Efficient solar water heating system with heat retention technology and backup heating for uninterrupted hot water supply.",
      price: 35000,
      originalPrice: 42000,
      category: "heaters",
      categoryDisplay: "Water Heaters",
      rating: 4.3,
      reviews: 58,
      image: "https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=400&h=400&fit=crop",
      features: ["100L Capacity", "Heat Retention", "Backup Heating", "Energy Saving", "Auto Temperature Control"],
      tags: ["eco-friendly", "energy-saving"],
      stock: 15,
      isFeatured: false,
      specs: { capacity: "100L", type: "Thermal", warranty: "7 years", backup: "Electric", efficiency: "85%" },
    },
    {
      id: 8,
      name: "Solar Street Light 30W",
      description: "Automatic solar-powered street light",
      fullDescription: "Smart street light with motion sensor, automatic dusk-to-dawn operation, and long battery life for energy-efficient outdoor lighting.",
      price: 5500,
      originalPrice: 7500,
      category: "lighting",
      categoryDisplay: "Solar Lighting",
      rating: 4.2,
      reviews: 91,
      image: "https://images.unsplash.com/photo-1572372747522-4c6c8d1f2b5c?w=400&h=400&fit=crop",
      features: ["30W LED", "Motion Sensor", "Auto On/Off", "2-day Backup", "Weatherproof"],
      tags: ["outdoor", "smart-lighting"],
      stock: 45,
      isFeatured: false,
      specs: { power: "30W", battery: "Li-ion", warranty: "3 years", sensor: "Motion", autonomy: "2 days" },
    },
  ];

  // Featured products slideshow data
  const featuredSlides = [
    {
      id: 1,
      title: "Best Selling Solar Kit",
      description: "Complete 3kW solar system for homes. Save up to 90% on electricity bills.",
      productId: 6,
      bgColor: "#123249",
      textColor: "white",
      cta: "View Details",
    },
    {
      id: 2,
      title: "Premium Solar Panels",
      description: "300W monocrystalline panels with 25-year warranty. High efficiency in all conditions.",
      productId: 1,
      bgColor: "#2D5A74",
      textColor: "white",
      cta: "Learn More",
    },
    {
      id: 3,
      title: "Smart Solar Inverters",
      description: "Hybrid inverters with WiFi monitoring. Seamless grid-tie functionality.",
      productId: 2,
      bgColor: "#447793",
      textColor: "white",
      cta: "Explore",
    },
    {
      id: 4,
      title: "Long-life Solar Batteries",
      description: "150Ah deep cycle batteries with 10-year warranty. Maintenance-free operation.",
      productId: 3,
      bgColor: "#2D5A74",
      textColor: "white",
      cta: "Shop Now",
    },
  ];

  // FIXED: Helper function to get full image URL
  const getFullImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    
    // If it's already a full URL (starts with http or https)
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
      return imageUrl;
    }
    
    // If it's a local path starting with /uploads
    if (imageUrl.startsWith('/uploads/')) {
      return `http://localhost:5000${imageUrl}`;
    }
    
    // If it's a relative path
    if (imageUrl.startsWith('uploads/')) {
      return `http://localhost:5000/${imageUrl}`;
    }
    
    // Default fallback
    return imageUrl;
  };

  // FIXED: Helper function to get default image based on category
  const getDefaultImage = (category) => {
    const categoryMap = {
      'Solar Panels': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'panels': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'Inverters': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
      'inverters': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
      'Batteries': 'https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=400&h=400&fit=crop',
      'batteries': 'https://images.unsplash.com/photo-1620714223084-8fcacc6dfd8d?w=400&h=400&fit=crop',
      'Controllers': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
      'controllers': 'https://images.unsplash.com/photo-1559302995-f9d4c6d1a2b5?w=400&h=400&fit=crop',
      'Accessories': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'accessories': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'Complete Kits': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'kits': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'Water Heaters': 'https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=400&h=400&fit=crop',
      'heaters': 'https://images.unsplash.com/photo-1625602812206-5ec545ca1231?w=400&h=400&fit=crop',
      'Solar Lighting': 'https://images.unsplash.com/photo-1572372747522-4c6c8d1f2b5c?w=400&h=400&fit=crop',
      'lighting': 'https://images.unsplash.com/photo-1572372747522-4c6c8d1f2b5c?w=400&h=400&fit=crop',
      'Other': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop',
      'other': 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop'
    };
    return categoryMap[category] || 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=400&fit=crop';
  };

  // FIXED: Helper function to map category names to IDs
  const getCategoryId = (categoryName) => {
    const categoryMap = {
      'Solar Panels': 'panels',
      'Inverters': 'inverters',
      'Batteries': 'batteries',
      'Controllers': 'controllers',
      'Accessories': 'accessories',
      'Complete Kits': 'kits',
      'Water Heaters': 'heaters',
      'Solar Lighting': 'lighting',
      'Other': 'other'
    };
    return categoryMap[categoryName] || 'other';
  };

  // FIXED: Helper function to map category ID to display name
  const getCategoryName = (categoryId) => {
    const categoryMap = {
      'panels': 'Solar Panels',
      'inverters': 'Inverters',
      'batteries': 'Batteries',
      'controllers': 'Controllers',
      'accessories': 'Accessories',
      'kits': 'Complete Kits',
      'heaters': 'Water Heaters',
      'lighting': 'Solar Lighting',
      'other': 'Other'
    };
    return categoryMap[categoryId] || categoryId;
  };

  // Fetch products from database
  const fetchProductsFromDatabase = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/products/active`);
      
      if (response.data.success) {
        const mappedProducts = response.data.data.map(product => {
          // Get the image URL
          let imageUrl = product.imageUrl;
          
          // If no imageUrl, use default
          if (!imageUrl) {
            imageUrl = getDefaultImage(product.category);
          } else {
            // Ensure full URL for local files
            imageUrl = getFullImageUrl(imageUrl);
          }
          
          return {
            id: product._id,
            name: product.name,
            description: product.description,
            fullDescription: product.fullDescription || product.description,
            price: product.price,
            originalPrice: product.originalPrice || product.price,
            category: getCategoryId(product.category),
            categoryDisplay: product.category,
            rating: product.rating || 4.5,
            reviews: product.reviews || 0,
            image: imageUrl,
            features: product.features || [],
            tags: product.tags || [],
            stock: product.stock || 0,
            isFeatured: product.isFeatured || false,
            isBestSeller: product.isBestSeller || false,
            specs: product.specifications || {},
            isActive: product.isActive
          };
        });
        
        setDbProducts(mappedProducts);
        setProducts(mappedProducts);
        setFilteredProducts(mappedProducts);
        setError(null);
        console.log('Products loaded from database:', mappedProducts.length);
        console.log('Sample product image:', mappedProducts[0]?.image);
      } else {
        setError('Failed to fetch products from server');
        // Use static data as fallback
        setProducts(productData);
        setFilteredProducts(productData);
        setDbProducts(productData);
      }
    } catch (err) {
      console.error('Error fetching products:', err);
      setError('Failed to connect to server. Using sample data.');
      // Use static data as fallback
      setProducts(productData);
      setFilteredProducts(productData);
      setDbProducts(productData);
    } finally {
      setLoading(false);
    }
  };

  // Fetch best sellers from database
  const fetchBestSellersFromDatabase = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/products/best-sellers`);
      
      if (response.data.success) {
        const mappedBestSellers = response.data.data.map(product => {
          let imageUrl = product.imageUrl;
          
          if (!imageUrl) {
            imageUrl = getDefaultImage(product.category);
          } else {
            imageUrl = getFullImageUrl(imageUrl);
          }
          
          return {
            id: product._id,
            name: product.name,
            description: product.description,
            price: product.price,
            originalPrice: product.originalPrice || product.price,
            category: getCategoryId(product.category),
            categoryDisplay: product.category,
            rating: product.rating || 4.5,
            reviews: product.reviews || 0,
            image: imageUrl,
            features: product.features || [],
            tags: product.tags || [],
            isBestSeller: product.isBestSeller || false,
            isActive: product.isActive
          };
        });
        
        setDbBestSellers(mappedBestSellers);
      }
    } catch (err) {
      console.error('Error fetching best sellers:', err);
      // Use static best sellers as fallback
      const staticBestSellers = productData.filter(p => p.tags.includes("best-seller"));
      setDbBestSellers(staticBestSellers);
    }
  };

  useEffect(() => {
    fetchProductsFromDatabase();
    fetchBestSellersFromDatabase();
  }, []);

  // Initialize chat when opened
  useEffect(() => {
    if (isChatOpen && chatMessages.length === 0) {
      initChat();
    }
  }, [isChatOpen]);

  // Close mobile menu when window resize above mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  // Use database products if available, otherwise use static data
  const allProducts = dbProducts.length > 0 ? dbProducts : products;
  
  // Best selling products from database or static
  const bestSellingProducts = dbBestSellers.length > 0 
    ? dbBestSellers.map(prod => ({
        id: prod.id,
        name: prod.name,
        description: prod.description,
        price: prod.price,
        originalPrice: prod.originalPrice || prod.price,
        category: prod.category,
        categoryDisplay: prod.categoryDisplay,
        rating: prod.rating || 4.5,
        reviews: prod.reviews || 0,
        image: prod.image,
        features: prod.features || [],
        tags: prod.tags || [],
        isBestSeller: prod.isBestSeller || false,
        isActive: prod.isActive
      }))
    : productData.filter((p) => p.tags.includes("best-seller"));

  // Categories Data with proper structure
  const categoriesData = [
    { id: "panels", name: "Solar Panels", icon: "☀️", description: "High-efficiency solar panels for residential and commercial use" },
    { id: "inverters", name: "Inverters", icon: "⚡", description: "Convert DC to AC power with smart monitoring" },
    { id: "batteries", name: "Batteries", icon: "🔋", description: "Energy storage solutions for backup power" },
    { id: "controllers", name: "Controllers", icon: "🎛️", description: "Charge controllers for optimal battery management" },
    { id: "accessories", name: "Accessories", icon: "🔧", description: "Mounting structures and installation accessories" },
    { id: "kits", name: "Complete Kits", icon: "📦", description: "Complete solar systems with installation" },
    { id: "heaters", name: "Water Heaters", icon: "♨️", description: "Solar water heating systems" },
    { id: "lighting", name: "Solar Lighting", icon: "💡", description: "Outdoor and indoor solar lighting" },
  ];

  // Update categories when products change
  useEffect(() => {
    const updatedCategories = categoriesData.map(cat => ({
      ...cat,
      count: allProducts.filter(p => p.category === cat.id).length,
      products: allProducts.filter(p => p.category === cat.id)
    }));
    setCategories(updatedCategories);
  }, [allProducts]);

  // Auto slide for featured products
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredSlides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Continuous auto-scroll for Best Selling Products
  useEffect(() => {
    const scrollContainer = bestSellingRef.current;
    if (!scrollContainer) return;

    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;

    autoScrollRef.current = setInterval(() => {
      setBestSellingScrollPos((prev) => {
        if (prev >= maxScroll) {
          scrollContainer.scrollTo({ left: 0, behavior: "instant" });
          return 0;
        } else {
          const newPos = prev + 1;
          scrollContainer.scrollTo({ left: newPos, behavior: "smooth" });
          return newPos;
        }
      });
    }, 30);

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };
  }, [bestSellingProducts]);

  // Filter and search functionality
  useEffect(() => {
    let filtered = [...allProducts];

    // Filter by category
    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (product) => product.category === selectedCategory
      );
    }

    // Filter by search query
    if (searchQuery) {
      filtered = filtered.filter(
        (product) =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.category.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filter by price range
    filtered = filtered.filter(
      (product) =>
        product.price >= priceRange[0] && product.price <= priceRange[1]
    );

    // Sort products
    switch (sortBy) {
      case "price-low":
        filtered.sort((a, b) => a.price - b.price);
        break;
      case "price-high":
        filtered.sort((a, b) => b.price - a.price);
        break;
      case "rating":
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      case "name":
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      default:
        // featured - keep original order
        break;
    }

    setFilteredProducts(filtered);

    // Generate search suggestions
    if (searchQuery) {
      const suggestions = allProducts
        .filter((product) =>
          product.name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .slice(0, 5);
      setSearchSuggestions(suggestions);
    } else {
      setSearchSuggestions([]);
    }
  }, [selectedCategory, searchQuery, priceRange, sortBy, allProducts]);

  // Chatbot functions
  const initChat = () => {
    addChatMessage(
      "Hi 👋 Welcome to Blue Sky Energy Products! I'm here to help you with product selection, pricing, and solar solutions. How can I assist you today?",
      "bot"
    );
    setTimeout(() => {
      addChatMessage("Choose an option to get started:", "bot");
      setQuickReplies([
        "🏠 Residential Solutions",
        "🏢 Commercial Solutions",
        "💰 Price & Discounts",
        "⚡ Product Comparison",
        "📦 Complete Kits",
      ]);
    }, 800);
  };

  const addChatMessage = (text, sender) => {
    const time = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const newMessage = {
      text,
      sender,
      time,
      id: Date.now(),
    };
    setChatMessages((prev) => [...prev, newMessage]);
    if (sender === "user") {
      setMessageCount((prev) => prev + 1);
    }
  };

  // Keyword Logic for Products Page
  const matchKeywords = (input) => {
    const text = input.toLowerCase();

    if (text.includes("panel") || text.includes("solar panel") || text.includes("300w")) {
      return "☀️ Solar Panels\n\n• 300W Monocrystalline Panel\n• Price: ₹18,500 (Save ₹3,000)\n• Efficiency: 21.5%\n• Warranty: 25 years\n• Features: Anti-reflective coating, high low-light performance\n• Perfect for: Residential rooftops\n\nWant more details or want to compare with other panels?";
    }

    if (text.includes("inverter") || text.includes("5kw") || text.includes("hybrid")) {
      return "⚡ SmartSolar Inverter 5kW\n\n• Price: ₹45,000 (Save ₹7,000)\n• Type: Hybrid with battery backup\n• Features: WiFi monitoring, pure sine wave\n• Warranty: 5 years\n• Perfect for: Homes & small businesses\n\nIdeal for grid-tie systems with backup!";
    }

    if (text.includes("battery") || text.includes("150ah") || text.includes("storage")) {
      return "🔋 Solar Battery 150Ah\n\n• Price: ₹16,500 (Save ₹2,500)\n• Capacity: 150Ah Deep Cycle\n• Warranty: 10 years\n• Features: Maintenance-free, fast charging\n• Cycles: 2000+\n\nPerfect for backup power and off-grid systems!";
    }

    if (text.includes("kit") || text.includes("3kw") || text.includes("complete") || text.includes("system")) {
      return "📦 Solar Home Kit 3kW\n\n• Price: ₹1,85,000 (Save ₹40,000)\n• Complete system with installation\n• Includes: 6 panels, inverter, batteries\n• Warranty: 5 years comprehensive\n• Savings: Up to 90% on electricity bills\n\nMost popular kit for Indian homes!";
    }

    if (text.includes("residential") || text.includes("home") || text.includes("house")) {
      return "🏠 Residential Solar Solutions\n\nRecommended for homes:\n1. 3kW Complete Kit - ₹1,85,000\n2. 5kW System - ₹2,80,000\n3. 10kW System - ₹5,20,000\n\nAverage ROI: 4-5 years\nMonthly Savings: ₹3,000-₹12,000\nSubsidies Available: 20-40%\n\nNeed a customized quote for your home?";
    }

    if (text.includes("commercial") || text.includes("business") || text.includes("factory") || text.includes("industrial")) {
      return "🏢 Commercial Solar Solutions\n\nRecommended for businesses:\n• 10kW System - ₹5,20,000\n• 20kW System - ₹9,80,000\n• 50kW System - ₹22,00,000\n• 100kW+ Systems - Custom pricing\n\nBenefits: Tax savings, 70% cost reduction, green certification\n\nWant commercial solar details?";
    }

    if (text.includes("price") || text.includes("cost") || text.includes("discount") || text.includes("sale")) {
      return "💰 Price & Discounts\n\nCurrent Offers:\n• Solar Panels: Save ₹3,000\n• Inverters: Save ₹7,000\n• Batteries: Save ₹2,500\n• Complete Kits: Save ₹40,000\n\nFinancing Options:\n• 0% EMI for 6 months\n• Bank loan assistance\n• Subsidy guidance\n\nSpecial: Free installation on kits above 5kW!";
    }

    if (text.includes("compare") || text.includes("difference") || text.includes("vs") || text.includes("which")) {
      return "⚡ Product Comparison\n\nPanel vs Inverter vs Battery:\n• Solar Panel: Generates electricity\n• Inverter: Converts DC to AC\n• Battery: Stores excess power\n• Complete Kit: All components\n\nBest for:\n• Only high bills: Grid-tie system\n• Power cuts: Hybrid system\n• Off-grid: Complete with batteries\n\nNeed help choosing?";
    }

    if (text.includes("warranty") || text.includes("guarantee") || text.includes("quality")) {
      return "✅ Quality & Warranty\n\nOur Guarantees:\n• Solar Panels: 25 years\n• Inverters: 5 years\n• Batteries: 10 years\n• Installation: 5 years\n• Complete Systems: 5 years comprehensive\n\nAll products: ISO certified, grade-A materials\nFree maintenance for first year!";
    }

    if (text.includes("installation") || text.includes("install") || text.includes("setup")) {
      return "🔧 Installation Services\n\n• Professional certified installers\n• Site survey & design\n• Complete installation in 3-7 days\n• Government approval assistance\n• Subsidy application help\n• Free maintenance training\n\nWe handle everything from A to Z!";
    }

    if (text.includes("subsidy") || text.includes("government") || text.includes("scheme") || text.includes("incentive")) {
      return "🏛️ Government Subsidies\n\nAvailable Subsidies:\n• Residential: 20-40%\n• Commercial: 30% for MSME\n• Agricultural: Up to 50%\n• Rooftop Solar: Additional benefits\n\nWe Provide:\n• Complete subsidy application\n• Document preparation\n• Follow-up with authorities\n• 100% subsidy success rate!";
    }

    if (text.includes("emi") || text.includes("finance") || text.includes("loan") || text.includes("payment")) {
      return "💳 Payment Options\n\n• Cash/Card/UPI: Full payment\n• EMI: 0% for 6 months\n• Bank Loans: We provide assistance\n• Corporate Credit: Available\n• Flexible Payments: 50% advance, 50% after installation\n\nNo cost EMI on all products above ₹50,000!";
    }

    return `I understand you're interested in solar products! Blue Sky Energy offers ${allProducts.length} products including:\n• Solar Panels (300W to 500W)\n• Inverters (1kW to 100kW)\n• Batteries (50Ah to 200Ah)\n• Complete Home Kits\n• Commercial Systems\n• Installation Services\n\nWhat specific product or information are you looking for?`;
  };

  // Lead Capture Logic for Product Enquiries
  const handleLeadCapture = (input) => {
    if (leadStep === 0) {
      setUserData((prev) => ({ ...prev, name: input }));
      setLeadStep(1);
      addChatMessage(
        `Nice to meet you, ${input}! 😊\n\nWhich solar product are you most interested in?`,
        "bot"
      );
    } else if (leadStep === 1) {
      setUserData((prev) => ({ ...prev, productInterest: input }));
      setLeadStep(2);
      addChatMessage(
        "Great choice! Could you please share your email address for detailed information?",
        "bot"
      );
    } else if (leadStep === 2) {
      setUserData((prev) => ({ ...prev, email: input }));
      setLeadStep(3);
      addChatMessage(
        "Perfect! And what's your phone number so our solar expert can contact you?",
        "bot"
      );
    } else if (leadStep === 3) {
      setUserData((prev) => ({ ...prev, phone: input }));
      setLeadCaptured(true);
      setAwaitingLeadInfo(false);
      saveEnquiry({ ...userData, phone: input });
      addChatMessage(
        `Excellent! Thank you ${userData.name}! ✅\n\nEnquiry received for: ${userData.productInterest}\n\nOur solar expert will contact you within 24 hours with:\n1. Detailed product information\n2. Customized pricing\n3. Subsidy details\n4. Installation timeline\n\nWelcome to Blue Sky Energy! 🌞`,
        "bot"
      );
    }
  };

  const saveEnquiry = (data) => {
    const enquiryId = `product_enquiry_${Date.now()}`;
    localStorage.setItem(
      enquiryId,
      JSON.stringify({
        ...data,
        timestamp: new Date(),
        source: "products_chatbot",
      })
    );
    console.log("Product Enquiry Saved:", data);
  };

  const handleChatSend = () => {
    const text = chatInput.trim();
    if (!text) return;

    addChatMessage(text, "user");
    setChatInput("");
    setQuickReplies([]);

    setTimeout(() => {
      if (awaitingLeadInfo) {
        handleLeadCapture(text);
      } else {
        const response = matchKeywords(text);
        addChatMessage(response, "bot");

        // Trigger Lead Capture after 2 interactions
        if (!leadCaptured && messageCount >= 1) {
          setTimeout(() => {
            addChatMessage(
              "Want detailed pricing and expert advice? 📋\n\nWhat's your name?",
              "bot"
            );
            setAwaitingLeadInfo(true);
          }, 1500);
        }
      }
    }, 600);
  };

  const handleQuickReply = (option) => {
    setChatInput(option);
    setTimeout(() => {
      handleChatSend();
    }, 100);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleChatSend();
    }
  };

  // Handle search
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle category selection
  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    setMobileMenuOpen(false);
    const element = document.getElementById(`category-${categoryId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Wishlist functionality
  const toggleWishlist = (productId) => {
    if (wishlist.includes(productId)) {
      setWishlist(wishlist.filter((id) => id !== productId));
    } else {
      setWishlist([...wishlist, productId]);
    }
  };

  // Cart functionality
  const addToCart = (product) => {
    const existingItem = cart.find((item) => item.id === product.id);
    if (existingItem) {
      setCart(
        cart.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      );
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
    alert(`${product.name} added to cart!`);
  };

  // Compare functionality
  const toggleCompare = (productId) => {
    if (compareList.includes(productId)) {
      setCompareList(compareList.filter((id) => id !== productId));
    } else {
      if (compareList.length >= 4) {
        alert("You can compare up to 4 products at once.");
        return;
      }
      setCompareList([...compareList, productId]);
    }
  };

  // Enquiry modal
  const openEnquiryModal = (product) => {
    setEnquiryModal({ open: true, product });
  };

  const closeEnquiryModal = () => {
    setEnquiryModal({ open: false, product: null });
  };

  const handleEnquirySubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const enquiryData = {
      name: formData.get("name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      product: enquiryModal.product.name,
      message: formData.get("message"),
    };
    console.log("Enquiry submitted:", enquiryData);
    alert("Thank you for your enquiry! We will contact you soon.");
    closeEnquiryModal();
  };

  // Handle Enquiry Now with WhatsApp and Call options
  const handleEnquiryNow = (product) => {
    const whatsappMessage = `
*Product Enquiry - Blue Sky Energy*
----------------------------------
*Product:* ${product.name}
*Price:* ₹${product.price?.toLocaleString()}
*Category:* ${product.categoryDisplay || getCategoryName(product.category)}

Hi, I'm interested in this product and would like more information about:
• Pricing and offers
• Technical specifications
• Installation process
• Warranty details
• Availability

Please provide me with complete details. Thank you!
    `.trim();

    const encodedMessage = encodeURIComponent(whatsappMessage);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  // FREE DEMO HANDLER
  const handleFreeDemo = (product) => {
    setDemoModal({
      open: true,
      product: product
    });
  };

  const handleCloseDemoModal = () => {
    setDemoModal({
      open: false,
      product: null
    });
  };

  const handleSubmitDemo = async (formData) => {
    try {
      const demoId = `demo_${Date.now()}`;
      localStorage.setItem(demoId, JSON.stringify({
        ...formData,
        submittedAt: new Date().toISOString(),
        source: 'products_page_free_demo'
      }));

      const response = await axios.post(`${API_BASE_URL}/free-demo`, formData);
      
      if (response.data.success) {
        console.log('Demo request saved to database:', response.data.data);
      }
      
      return Promise.resolve();
    } catch (error) {
      console.error('Error saving demo request:', error);
      return Promise.resolve();
    }
  };

  // View product details
  const viewProductDetails = (productId) => {
    navigate(`/product/${productId}`);
  };

  // Remove from cart
  const removeFromCart = (productId) => {
    setCart(cart.filter((item) => item.id !== productId));
  };

  // Update cart quantity
  const updateCartQuantity = (productId, newQuantity) => {
    if (newQuantity < 1) {
      removeFromCart(productId);
      return;
    }
    setCart(
      cart.map((item) =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  // Calculate cart total
  const cartTotal = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  // Calculate savings
  const cartSavings = cart.reduce(
    (total, item) => total + (item.originalPrice - item.price) * item.quantity,
    0
  );

  // State for cart sidebar
  const [cartOpen, setCartOpen] = useState(false);

  const toggleCart = () => {
    setCartOpen(!cartOpen);
  };

  // Handle compare button
  const handleCompareClick = () => {
    if (compareList.length > 0) {
      setShowCompareModal(true);
    } else {
      alert("Please add products to compare first.");
    }
  };

  // Clear filters
  const clearFilters = () => {
    setSelectedCategory("all");
    setPriceRange([0, 500000]);
    setSearchQuery("");
    setSortBy("featured");
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Button styles
  const enquiryBtnStyle = {
    backgroundColor: "#25D366",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  };

  // FREE DEMO BUTTON STYLE
  const freeDemoBtnStyle = {
    backgroundColor: "#447793",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    gridColumn: "span 2",
    marginTop: "8px"
  };

  // Styles (keep all your existing styles from your original code)
  const styles = {
    container: {
      fontFamily: "Cambria, serif",
      backgroundColor: "#ffffff",
      minHeight: "100vh",
      overflowX: "hidden",
      width: "100%",
    },

    header: {
      backgroundColor: "white",
      color: "#123249",
      padding: "15px 5%",
      position: "sticky",
      top: 0,
      zIndex: 1000,
      boxShadow: "0 2px 10px rgba(6, 18, 33, 0.1)",
      borderBottom: "3px solid #447793",
    },
    headerContent: {
      maxWidth: "1400px",
      margin: "0 auto",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "15px",
      position: "relative",
    },
    logoContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    logo: {
      fontSize: "1.5rem",
      fontWeight: "800",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#123249",
      cursor: "pointer",
    },
    desktopNav: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
      marginLeft: "20px",
    },
    desktopNavLink: {
      color: "#123249",
      textDecoration: "none",
      fontSize: "0.95rem",
      fontWeight: "600",
      transition: "color 0.3s",
    },
    searchContainer: {
      width: "100%",
      maxWidth: "500px",
      position: "relative",
      flex: "1",
    },
    searchInput: {
      width: "100%",
      padding: "12px 45px 12px 20px",
      borderRadius: "25px",
      border: "2px solid #447793",
      fontSize: "1rem",
      backgroundColor: "white",
      color: "#123249",
    },
    searchIcon: {
      position: "absolute",
      right: "15px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#447793",
    },
    suggestionsBox: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      backgroundColor: "white",
      borderRadius: "10px",
      boxShadow: "0 5px 15px rgba(6, 18, 33, 0.1)",
      marginTop: "5px",
      zIndex: 1000,
      maxHeight: "300px",
      overflowY: "auto",
      border: "1px solid #447793",
    },
    suggestionItem: {
      padding: "10px 15px",
      borderBottom: "1px solid #DDE8ED",
      cursor: "pointer",
      color: "#123249",
    },
    headerActions: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap",
      justifyContent: "flex-end",
    },
    actionButton: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "8px 16px",
      borderRadius: "25px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      fontSize: "0.9rem",
    },
    actionCount: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.8rem",
      marginLeft: "5px",
    },
    menuButton: {
      display: "none",
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      color: "#123249",
    },
    
    // Mobile Menu
    mobileMenuOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(6, 18, 33, 0.5)",
      zIndex: 1001,
      display: mobileMenuOpen ? "block" : "none",
    },
    mobileMenu: {
      position: "fixed",
      top: 0,
      right: mobileMenuOpen ? "0" : "-100%",
      width: "280px",
      height: "100vh",
      backgroundColor: "white",
      boxShadow: "-5px 0 25px rgba(6, 18, 33, 0.15)",
      zIndex: 1002,
      transition: "right 0.3s ease",
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
    },
    mobileMenuHeader: {
      padding: "20px",
      borderBottom: "1px solid #DDE8ED",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    mobileMenuTitle: {
      fontSize: "1.2rem",
      fontWeight: "700",
      color: "#123249",
      margin: 0,
    },
    mobileMenuClose: {
      background: "none",
      border: "none",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#123249",
    },
    mobileMenuNav: {
      padding: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    mobileNavSection: {
      marginBottom: "15px",
    },
    mobileNavSectionTitle: {
      fontSize: "0.9rem",
      fontWeight: "600",
      color: "#2D5A74",
      marginBottom: "10px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    mobileNavLink: {
      display: "block",
      padding: "12px 0",
      color: "#123249",
      textDecoration: "none",
      fontSize: "1rem",
      fontWeight: "500",
      borderBottom: "1px solid #DDE8ED",
      transition: "color 0.3s",
    },

    // Featured Products Slideshow
    featuredSection: {
      padding: "30px 5%",
      backgroundColor: "#DDE8ED",
    },
    featuredContainer: {
      maxWidth: "1400px",
      margin: "0 auto",
      position: "relative",
    },
    featuredTitle: {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: "#123249",
      textAlign: "center",
      marginBottom: "20px",
    },
    slideshowContainer: {
      width: "100%",
      height: "300px",
      borderRadius: "15px",
      overflow: "hidden",
      position: "relative",
      boxShadow: "0 10px 30px rgba(6, 18, 33, 0.1)",
    },
    slide: {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0,
      transition: "opacity 1s ease-in-out",
      display: "flex",
      alignItems: "center",
      padding: "0 30px",
    },
    slideContent: {
      maxWidth: "100%",
      color: "white",
    },
    slideTitle: {
      fontSize: "1.8rem",
      fontWeight: "800",
      marginBottom: "10px",
      textShadow: "2px 2px 4px rgba(6, 18, 33, 0.3)",
    },
    slideDescription: {
      fontSize: "1rem",
      marginBottom: "20px",
      opacity: 0.9,
    },
    slideCTA: {
      backgroundColor: "#447793",
      color: "white",
      padding: "10px 25px",
      fontSize: "1rem",
      fontWeight: "bold",
      border: "none",
      borderRadius: "25px",
      cursor: "pointer",
      transition: "all 0.3s",
    },
    slideIndicator: {
      position: "absolute",
      bottom: "15px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "flex",
      gap: "8px",
    },
    indicatorDot: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.5)",
      cursor: "pointer",
      transition: "all 0.3s",
    },
    indicatorDotActive: {
      backgroundColor: "#447793",
      transform: "scale(1.2)",
    },

    // Best Selling Products
    bestSellingSection: {
      padding: "40px 5%",
      backgroundColor: "white",
      position: "relative",
      overflow: "hidden",
    },
    bestSellingTitle: {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: "20px",
      textAlign: "center",
    },
    bestSellingContainer: {
      width: "100%",
      overflow: "hidden",
      position: "relative",
    },
    bestSellingScroll: {
      display: "flex",
      gap: "15px",
      padding: "15px 5px",
      animation: "scroll 40s linear infinite",
    },
    bestSellingCard: {
      minWidth: "250px",
      backgroundColor: "white",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 5px 15px rgba(6, 18, 33, 0.08)",
      transition: "all 0.3s ease",
      border: "1px solid #DDE8ED",
      flexShrink: 0,
      position: "relative",
    },
    bestSellingBadge: {
      position: "absolute",
      top: "10px",
      left: "10px",
      backgroundColor: "#447793",
      color: "white",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "0.7rem",
      fontWeight: "600",
      zIndex: 2,
    },
    bestSellingImage: {
      width: "100%",
      height: "150px",
      backgroundColor: "#DDE8ED",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "2rem",
      color: "#123249",
      overflow: "hidden",
      transition: "transform 0.3s ease",
    },
    bestSellingImageHover: {
      transform: "scale(1.1)",
    },
    bestSellingContent: {
      padding: "15px",
    },
    bestSellingName: {
      fontSize: "1.1rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: "8px",
      height: "40px",
      overflow: "hidden",
    },
    bestSellingPriceContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "10px",
      flexWrap: "wrap",
    },
    bestSellingPrice: {
      fontSize: "1.5rem",
      fontWeight: "800",
      color: "#123249",
      display: "flex",
      alignItems: "center",
    },
    priceSymbol: {
      fontSize: "1.2rem",
      marginRight: "5px",
      fontWeight: "700",
    },
    bestSellingOriginalPrice: {
      fontSize: "0.9rem",
      color: "#2D5A74",
      textDecoration: "line-through",
    },
    bestSellingDiscount: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "2px 8px",
      borderRadius: "10px",
      fontSize: "0.7rem",
      fontWeight: "600",
    },
    bestSellingRating: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      marginBottom: "10px",
      fontSize: "0.9rem",
      color: "#447793",
    },
    bestSellingActions: {
      display: "flex",
      gap: "8px",
      flexDirection: "column",
    },
    cardActionButton: {
      width: "100%",
      padding: "8px",
      borderRadius: "6px",
      border: "none",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      fontSize: "0.85rem",
    },
    enquiryBtn: {
      backgroundColor: "#25D366",
      color: "white",
    },
    callBtn: {
      backgroundColor: "#2D5A74",
      color: "white",
    },
    viewDetailsBtn: {
      backgroundColor: "#447793",
      color: "white",
      gridColumn: "span 2",
    },
    freeDemoBtn: {
      backgroundColor: "#447793",
      color: "white",
      gridColumn: "span 2",
    },

    // Category Navigation
    categoryNavSection: {
      padding: "20px 5%",
      backgroundColor: "white",
      borderBottom: "1px solid #DDE8ED",
    },
    categoryNavContainer: {
      maxWidth: "1400px",
      margin: "0 auto",
      overflowX: "auto",
      paddingBottom: "10px",
    },
    categoryNavTitle: {
      fontSize: "1.5rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: "15px",
      textAlign: "center",
    },
    categoryNavList: {
      display: "flex",
      gap: "10px",
      padding: "10px 0",
      minWidth: "fit-content",
    },
    categoryNavItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "12px 20px",
      borderRadius: "10px",
      cursor: "pointer",
      transition: "all 0.3s",
      border: "1px solid transparent",
      textAlign: "center",
      minWidth: "120px",
      backgroundColor: "#DDE8ED",
    },
    categoryNavItemActive: {
      backgroundColor: "#447793",
      borderColor: "#447793",
    },
    categoryNavItemContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "8px",
    },
    categoryNavIcon: {
      fontSize: "1.8rem",
    },
    categoryNavName: {
      fontSize: "0.9rem",
      fontWeight: "600",
    },
    categoryNavCount: {
      backgroundColor: "white",
      color: "#123249",
      padding: "2px 6px",
      borderRadius: "10px",
      fontSize: "0.7rem",
      fontWeight: "600",
      marginTop: "5px",
    },

    // Category Section
    categorySection: {
      padding: "40px 5%",
      backgroundColor: "#ffffff",
    },
    categorySectionInner: {
      maxWidth: "1400px",
      margin: "0 auto",
    },
    categoryHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "25px",
      paddingBottom: "15px",
      borderBottom: "2px solid #447793",
    },
    categoryTitle: {
      fontSize: "1.8rem",
      fontWeight: "700",
      color: "#123249",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    categoryDescription: {
      fontSize: "1rem",
      color: "#2D5A74",
      marginTop: "5px",
    },
    viewAllButton: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      backgroundColor: "transparent",
      color: "#447793",
      border: "1px solid #447793",
      padding: "8px 16px",
      borderRadius: "20px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      fontSize: "0.9rem",
    },
    categoryProductsGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
      gap: "20px",
    },
    categoryProductCard: {
      backgroundColor: "white",
      borderRadius: "12px",
      overflow: "hidden",
      boxShadow: "0 5px 15px rgba(6, 18, 33, 0.08)",
      transition: "all 0.3s ease",
      border: "1px solid #DDE8ED",
      position: "relative",
    },
    categoryProductImage: {
      width: "100%",
      height: "180px",
      backgroundColor: "#DDE8ED",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#123249",
      fontSize: "2rem",
      fontWeight: "600",
      position: "relative",
      overflow: "hidden",
    },
    productImageTag: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.5s ease",
    },
    categoryProductBadge: {
      position: "absolute",
      top: "8px",
      right: "8px",
      backgroundColor: "#447793",
      color: "white",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "0.7rem",
      fontWeight: "600",
      zIndex: 2,
    },
    categoryProductContent: {
      padding: "15px",
    },
    categoryProductName: {
      fontSize: "1.1rem",
      fontWeight: "700",
      color: "#123249",
      marginBottom: "6px",
      height: "40px",
      overflow: "hidden",
    },
    categoryProductDescription: {
      color: "#2D5A74",
      fontSize: "0.9rem",
      marginBottom: "12px",
      height: "35px",
      overflow: "hidden",
    },
    categoryProductPrice: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginBottom: "12px",
      flexWrap: "wrap",
    },
    categoryCurrentPrice: {
      fontSize: "1.3rem",
      fontWeight: "800",
      color: "#123249",
      display: "flex",
      alignItems: "center",
    },
    categoryPriceSymbol: {
      fontSize: "1rem",
      marginRight: "5px",
    },
    categoryOriginalPrice: {
      fontSize: "0.9rem",
      color: "#2D5A74",
      textDecoration: "line-through",
    },
    categoryDiscountBadge: {
      backgroundColor: "#DDE8ED",
      color: "#123249",
      padding: "2px 6px",
      borderRadius: "4px",
      fontSize: "0.7rem",
      fontWeight: "600",
    },
    categoryProductRating: {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      marginBottom: "12px",
      fontSize: "0.9rem",
      color: "#447793",
    },
    categoryProductActions: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "8px",
    },
    categoryWishlistButton: {
      position: "absolute",
      top: "12px",
      right: "12px",
      backgroundColor: "white",
      border: "none",
      width: "35px",
      height: "35px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(6, 18, 33, 0.2)",
      transition: "all 0.3s",
      zIndex: 2,
    },
    categoryCompareButton: {
      position: "absolute",
      top: "57px",
      right: "12px",
      backgroundColor: "white",
      border: "none",
      width: "35px",
      height: "35px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(6, 18, 33, 0.2)",
      transition: "all 0.3s",
      zIndex: 2,
    },

    // Cart Sidebar
    cartSidebar: {
      position: "fixed",
      top: "0",
      right: "-100%",
      width: "100%",
      maxWidth: "400px",
      height: "100vh",
      backgroundColor: "white",
      boxShadow: "-5px 0 25px rgba(6, 18, 33, 0.15)",
      zIndex: 1001,
      transition: "right 0.3s ease",
      display: "flex",
      flexDirection: "column",
    },
    cartSidebarOpen: {
      right: "0",
    },
    cartHeader: {
      padding: "15px",
      borderBottom: "1px solid #DDE8ED",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    cartTitle: {
      fontSize: "1.3rem",
      fontWeight: "700",
      color: "#123249",
    },
    cartClose: {
      backgroundColor: "transparent",
      border: "none",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#2D5A74",
    },
    cartItems: {
      flex: 1,
      overflowY: "auto",
      padding: "15px",
    },
    cartItem: {
      display: "flex",
      gap: "12px",
      padding: "12px 0",
      borderBottom: "1px solid #DDE8ED",
    },
    cartItemImage: {
      width: "60px",
      height: "60px",
      backgroundColor: "#DDE8ED",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.2rem",
      color: "#123249",
    },
    cartItemContent: {
      flex: 1,
    },
    cartItemName: {
      fontWeight: "600",
      marginBottom: "5px",
      color: "#123249",
      fontSize: "0.95rem",
    },
    cartItemPrice: {
      color: "#447793",
      fontWeight: "700",
      marginBottom: "8px",
      fontSize: "0.9rem",
    },
    cartItemActions: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    quantityButton: {
      width: "25px",
      height: "25px",
      borderRadius: "50%",
      border: "1px solid #DDE8ED",
      backgroundColor: "white",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "0.8rem",
      color: "#123249",
    },
    quantityInput: {
      width: "35px",
      textAlign: "center",
      border: "1px solid #DDE8ED",
      borderRadius: "5px",
      padding: "4px",
      fontSize: "0.9rem",
      color: "#123249",
    },
    removeButton: {
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      padding: "4px 8px",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "0.75rem",
    },
    cartFooter: {
      padding: "15px",
      borderTop: "1px solid #DDE8ED",
    },
    cartTotal: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
      fontWeight: "600",
      fontSize: "1.1rem",
      color: "#123249",
    },
    cartSavings: {
      color: "#447793",
      marginBottom: "15px",
      fontSize: "0.85rem",
    },
    checkoutButton: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#447793",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontSize: "1rem",
      fontWeight: "600",
      cursor: "pointer",
    },

    // Chatbot Styles
    chatbotContainer: {
      position: "fixed",
      bottom: "15px",
      right: "15px",
      zIndex: 9999,
      fontFamily: "Cambria, serif",
    },
    chatToggleBtn: {
      position: "fixed",
      bottom: "15px",
      right: "15px",
      width: "55px",
      height: "55px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      border: "none",
      fontSize: "22px",
      cursor: "pointer",
      boxShadow: "0 6px 20px rgba(68, 119, 147, 0.3)",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "10000",
      padding: "0",
      animation: "pulse 2s infinite",
    },
    chatWindow: {
      position: "fixed",
      bottom: "80px",
      right: "15px",
      width: "calc(100vw - 40px)",
      maxWidth: "380px",
      height: "500px",
      maxHeight: "65vh",
      background: "white",
      borderRadius: "16px",
      boxShadow: "0 10px 40px rgba(6, 18, 33, 0.15)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      zIndex: "9999",
      transition: "all 0.3s ease",
      opacity: 0,
      visibility: "hidden",
      transform: "translateY(20px)",
      border: "1px solid #DDE8ED",
    },
    chatWindowOpen: {
      opacity: "1",
      visibility: "visible",
      transform: "translateY(0)",
    },
    chatHeader: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      padding: "14px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    },
    headerInfo: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    headerIcon: {
      background: "rgba(255, 255, 255, 0.2)",
      padding: "8px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "35px",
      height: "35px",
      fontSize: "16px",
    },
    chatHeaderTitle: {
      margin: "0",
      fontSize: "14px",
      fontWeight: "600",
      lineHeight: "1.2",
      color: "white",
    },
    chatHeaderSubtitle: {
      margin: "0",
      fontSize: "11px",
      opacity: "0.9",
      lineHeight: "1.2",
      color: "#DDE8ED",
    },
    closeChatBtn: {
      background: "none",
      border: "none",
      color: "white",
      cursor: "pointer",
      fontSize: "16px",
      padding: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "opacity 0.2s",
    },
    quickReplies: {
      padding: "10px",
      display: "flex",
      flexWrap: "wrap",
      gap: "6px",
      background: "#DDE8ED",
      borderBottom: "1px solid #DDE8ED",
    },
    replyBtn: {
      background: "white",
      border: "1px solid #447793",
      color: "#123249",
      padding: "6px 12px",
      borderRadius: "15px",
      fontSize: "12px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      whiteSpace: "nowrap",
      fontWeight: "500",
      fontFamily: "Cambria, serif",
    },
    chatMessages: {
      flex: "1",
      padding: "14px",
      background: "#DDE8ED",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
    message: {
      maxWidth: "85%",
      padding: "10px 14px",
      borderRadius: "15px",
      fontSize: "13px",
      lineHeight: "1.5",
      whiteSpace: "pre-line",
      wordWrap: "break-word",
      position: "relative",
      animation: "fadeIn 0.3s ease",
    },
    botMessage: {
      background: "white",
      alignSelf: "flex-start",
      borderBottomLeftRadius: "4px",
      boxShadow: "0 2px 8px rgba(6, 18, 33, 0.08)",
      color: "#123249",
      border: "1px solid #DDE8ED",
    },
    userMessage: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      alignSelf: "flex-end",
      borderBottomRightRadius: "4px",
    },
    messageTime: {
      fontSize: "10px",
      marginTop: "5px",
      display: "block",
      opacity: "0.7",
    },
    chatInputArea: {
      padding: "14px",
      borderTop: "1px solid #DDE8ED",
      background: "white",
    },
    inputWrapper: {
      display: "flex",
      gap: "8px",
      marginBottom: "6px",
    },
    chatInput: {
      flex: "1",
      padding: "10px 14px",
      border: "1px solid #DDE8ED",
      borderRadius: "25px",
      outline: "none",
      fontSize: "13px",
      fontFamily: "Cambria, serif",
      transition: "border-color 0.2s",
      color: "#123249",
    },
    sendBtn: {
      background: "linear-gradient(135deg, #447793, #2D5A74)",
      color: "white",
      border: "none",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      transition: "all 0.2s ease",
      padding: "0",
    },
    footerText: {
      textAlign: "center",
      fontSize: "10px",
      color: "#2D5A74",
      margin: "0",
    },

    // Empty state
    emptyState: {
      textAlign: "center",
      padding: "60px 20px",
      color: "#2D5A74",
      backgroundColor: "white",
      borderRadius: "15px",
      margin: "20px 0",
    },

    // Footer
    footer: {
      backgroundColor: "#123249",
      color: "white",
      padding: "40px 5%",
      textAlign: "center",
    },
    footerContent: {
      maxWidth: "1400px",
      margin: "0 auto",
    },
    footerTitle: {
      fontSize: "1.5rem",
      fontWeight: "700",
      marginBottom: "15px",
      color: "white",
    },
    footerText: {
      color: "#DDE8ED",
      marginBottom: "25px",
      maxWidth: "800px",
      margin: "0 auto 25px",
      fontSize: "0.95rem",
    },
    contactInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "20px",
      marginBottom: "25px",
    },
    contactItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      color: "#DDE8ED",
    },

    // Loading state
    loadingContainer: {
      textAlign: "center",
      padding: "40px 20px",
      backgroundColor: "white",
      borderRadius: "15px",
      margin: "20px 0",
      color: "#123249",
    },

    // Main Content Styles
    mainContent: {
      padding: "20px 5%",
      backgroundColor: "#ffffff",
    },
  };

  // Responsive CSS Media Queries
  const responsiveCSS = `
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(calc(-265px * ${bestSellingProducts.length})); }
    }
    
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.05); }
      100% { transform: scale(1); }
    }
    
    @media (max-width: 1024px) {
      .menu-button {
        display: flex !important;
      }
      .search-container {
        order: 3 !important;
        max-width: 100% !important;
        width: 100% !important;
        margin-top: 10px !important;
      }
    }
    
    @media (max-width: 768px) {
      .header-actions .action-button span:not(.action-count) {
        display: none !important;
      }
      .category-products-grid {
        grid-template-columns: 1fr !important;
      }
    }
    
    @media (min-width: 481px) and (max-width: 768px) {
      .category-products-grid {
        grid-template-columns: repeat(2, 1fr) !important;
      }
    }
    
    @media (min-width: 769px) {
      .category-products-grid {
        grid-template-columns: repeat(3, 1fr) !important;
      }
    }
    
    @media (min-width: 992px) {
      .category-products-grid {
        grid-template-columns: repeat(4, 1fr) !important;
      }
    }
    
    .category-nav-container::-webkit-scrollbar {
      height: 6px;
    }
    .category-nav-container::-webkit-scrollbar-track {
      background: #DDE8ED;
      border-radius: 10px;
    }
    .category-nav-container::-webkit-scrollbar-thumb {
      background: #447793;
      border-radius: 10px;
    }
  `;

  return (
    <div style={styles.container}>
      <style>{responsiveCSS}</style>

      <FreeDemoModal
        isOpen={demoModal.open}
        onClose={handleCloseDemoModal}
        product={demoModal.product}
        onSubmit={handleSubmitDemo}
      />

      {cartOpen && <div className="cart-overlay" onClick={toggleCart}></div>}

      <div 
        className="mobile-menu-overlay" 
        style={styles.mobileMenuOverlay}
        onClick={toggleMobileMenu}
      ></div>

      <div style={styles.mobileMenu} className="mobile-menu">
        <div style={styles.mobileMenuHeader}>
          <h3 style={styles.mobileMenuTitle}>Menu</h3>
          <button 
            style={styles.mobileMenuClose}
            onClick={toggleMobileMenu}
          >
            ×
          </button>
        </div>
        <div style={styles.mobileMenuNav}>
          <div style={styles.mobileNavSection}>
            <div style={styles.mobileNavSectionTitle}>Solutions</div>
            <a href="/commercial" style={styles.mobileNavLink}>Commercial</a>
            <a href="/residential" style={styles.mobileNavLink}>Residential</a>
            <a href="/industrial" style={styles.mobileNavLink}>Industrial</a>
          </div>
          
          <div style={styles.mobileNavSection}>
            <div style={styles.mobileNavSectionTitle}>Company</div>
            <a href="/about" style={styles.mobileNavLink}>About Us</a>
            <a href="/contact" style={styles.mobileNavLink}>Contact Us</a>
            <a href="/products" style={styles.mobileNavLink}>Products</a>
            <a href="/more" style={styles.mobileNavLink}>More</a>
          </div>
          
          <div style={styles.mobileNavSection}>
            <div style={styles.mobileNavSectionTitle}>Account</div>
            <a href="/login" style={styles.mobileNavLink}>Login</a>
            <a href="/register" style={styles.mobileNavLink}>Register</a>
          </div>
        </div>
      </div>

      <header style={styles.header}>
        <div style={styles.headerContent} className="header-content">
          <div style={styles.logoContainer} className="logo-container">
            <div
              style={styles.logo}
              className="logo"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <span style={{ color: "#447793" }}>☀️</span>
              Blue Sky Energy
            </div>
          </div>

          <div style={styles.headerActions} className="header-actions">
            <button
              style={styles.actionButton}
              className="action-button"
              onClick={() => alert(`Wishlist has ${wishlist.length} items`)}
            >
              <HeartIcon filled={wishlist.length > 0} />
              <span>Wishlist</span>
              {wishlist.length > 0 && (
                <span style={styles.actionCount} className="action-count">
                  {wishlist.length}
                </span>
              )}
            </button>
            <button
              style={styles.actionButton}
              className="action-button"
              onClick={handleCompareClick}
            >
              <CompareIcon />
              <span>Compare</span>
              {compareList.length > 0 && (
                <span style={styles.actionCount} className="action-count">
                  {compareList.length}
                </span>
              )}
            </button>
            <button
              style={styles.actionButton}
              className="action-button"
              onClick={toggleCart}
            >
              <ShoppingCartIcon />
              <span>Cart</span>
              {cart.length > 0 && (
                <span style={styles.actionCount} className="action-count">
                  {cart.length}
                </span>
              )}
            </button>
            <button
              style={styles.menuButton}
              className="menu-button"
              onClick={toggleMobileMenu}
            >
              <MenuIcon />
            </button>
          </div>
        </div>

        <div style={styles.searchContainer} className="search-container">
          <input
            type="text"
            placeholder="Search solar products..."
            style={styles.searchInput}
            className="search-input"
            value={searchQuery}
            onChange={handleSearch}
            onFocus={(e) => e.target.style.borderColor = "#2D5A74"}
            onBlur={(e) => e.target.style.borderColor = "#447793"}
          />
          <div style={styles.searchIcon} className="search-icon">
            <SearchIcon />
          </div>

          {searchSuggestions.length > 0 && (
            <div style={styles.suggestionsBox} className="suggestions-box">
              {searchSuggestions.map((product) => (
                <div
                  key={product.id}
                  style={styles.suggestionItem}
                  className="suggestion-item"
                  onClick={() => {
                    setSearchQuery(product.name);
                    setSearchSuggestions([]);
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#DDE8ED")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "white")
                  }
                >
                  {product.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </header>

      <section style={styles.featuredSection} className="featured-section">
        <div style={styles.featuredContainer} className="featured-container">
          <h2 style={styles.featuredTitle} className="featured-title">
            Featured Solar Products
          </h2>
          <div style={styles.slideshowContainer} className="slideshow-container">
            {featuredSlides.map((slide, index) => (
              <div
                key={slide.id}
                style={{
                  ...styles.slide,
                  backgroundColor: slide.bgColor,
                  opacity: index === currentSlide ? 1 : 0,
                }}
                className="slide"
              >
                <div style={styles.slideContent} className="slide-content">
                  <h3 style={styles.slideTitle} className="slide-title">
                    {slide.title}
                  </h3>
                  <p style={styles.slideDescription} className="slide-description">
                    {slide.description}
                  </p>
                  <button
                    style={styles.slideCTA}
                    className="slide-cta"
                    onClick={() => viewProductDetails(slide.productId)}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#2D5A74")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "#447793")
                    }
                  >
                    {slide.cta}
                  </button>
                </div>
              </div>
            ))}

            <div style={styles.slideIndicator} className="slide-indicator">
              {featuredSlides.map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.indicatorDot,
                    ...(index === currentSlide
                      ? styles.indicatorDotActive
                      : {}),
                  }}
                  className="indicator-dot"
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section style={styles.bestSellingSection} className="best-selling-section">
        <h2 style={styles.bestSellingTitle} className="best-selling-title">
          Best Selling Products
        </h2>
        
        {loading ? (
          <div style={styles.loadingContainer} className="loading-container">
            <p>Loading best selling products...</p>
          </div>
        ) : error ? (
          <div style={{textAlign: 'center', padding: '30px', color: '#447793'}}>
            <p>{error}</p>
            <button 
              onClick={fetchProductsFromDatabase}
              style={{
                marginTop: '15px',
                padding: '8px 16px',
                backgroundColor: '#447793',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
            >
              Retry Connection
            </button>
          </div>
        ) : (
          <div style={styles.bestSellingContainer} className="best-selling-container">
            <div style={styles.bestSellingScroll} className="best-selling-scroll" ref={bestSellingRef}>
              {[
                ...bestSellingProducts,
                ...bestSellingProducts,
                ...bestSellingProducts,
              ].map((product, index) => (
                <div
                  key={`${product.id}-${index}`}
                  style={styles.bestSellingCard}
                  className="best-selling-card"
                >
                  <div style={styles.bestSellingBadge} className="best-selling-badge">Best Seller</div>

                  <div style={styles.bestSellingImage} className="best-selling-image">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.5s ease',
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = getDefaultImage(product.category);
                      }}
                    />
                  </div>

                  <div style={styles.bestSellingContent} className="best-selling-content">
                    <h3 style={styles.bestSellingName} className="best-selling-name">
                      {product.name}
                    </h3>

                    <div style={styles.bestSellingPriceContainer} className="best-selling-price-container">
                      <div style={styles.bestSellingPrice} className="best-selling-price">
                        <span style={styles.priceSymbol} className="price-symbol">₹</span>
                        {product.price.toLocaleString()}
                      </div>
                      {product.originalPrice > product.price && (
                        <>
                          <span style={styles.bestSellingOriginalPrice} className="best-selling-original-price">
                            ₹{product.originalPrice.toLocaleString()}
                          </span>
                          <span style={styles.bestSellingDiscount} className="best-selling-discount">
                            Save ₹
                            {(
                              product.originalPrice - product.price
                            ).toLocaleString()}
                          </span>
                        </>
                      )}
                    </div>

                    <div style={styles.bestSellingRating} className="best-selling-rating">
                      <span style={{color: "#447793"}}>
                        {"★".repeat(Math.floor(product.rating))}
                        {"☆".repeat(5 - Math.floor(product.rating))}
                      </span>
                      <span>({product.reviews})</span>
                    </div>

                    <div style={styles.bestSellingActions} className="best-selling-actions">
                      <button
                        style={{
                          ...styles.cardActionButton,
                          ...styles.enquiryBtn,
                        }}
                        className="card-action-button enquiry-btn"
                        onClick={() => handleEnquiryNow(product)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#128C7E")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "#25D366")
                        }
                      >
                        <WhatsAppIcon /> Enquire Now
                      </button>
                      <button
                        style={{
                          ...styles.cardActionButton,
                          ...styles.viewDetailsBtn,
                        }}
                        className="card-action-button view-details-btn"
                        onClick={() => viewProductDetails(product.id)}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#2D5A74")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = "#447793")
                        }
                      >
                        👁️ View Details
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>

      <section style={styles.categoryNavSection} className="category-nav-section">
        <div style={styles.categoryNavContainer} className="category-nav-container">
          <h3 style={styles.categoryNavTitle} className="category-nav-title">Browse by Category</h3>
          <div style={styles.categoryNavList} className="category-nav-list">
            <div
              style={{
                ...styles.categoryNavItem,
                ...(selectedCategory === "all" && styles.categoryNavItemActive),
              }}
              className="category-nav-item"
              onClick={() => setSelectedCategory("all")}
            >
              <div style={styles.categoryNavItemContent} className="category-nav-item-content">
                <span style={styles.categoryNavIcon} className="category-nav-icon">📦</span>
                <span style={{
                  ...styles.categoryNavName,
                  ...(selectedCategory === "all" && { color: "white" })
                }} className="category-nav-name">All Products</span>
              </div>
              <span style={{
                ...styles.categoryNavCount,
                ...(selectedCategory === "all" && { backgroundColor: "#DDE8ED", color: "#123249" })
              }} className="category-nav-count">{allProducts.length}</span>
            </div>
            
            {categories.map((category) => (
              <div
                key={category.id}
                style={{
                  ...styles.categoryNavItem,
                  ...(selectedCategory === category.id && styles.categoryNavItemActive),
                }}
                className="category-nav-item"
                onClick={() => handleCategorySelect(category.id)}
              >
                <div style={styles.categoryNavItemContent} className="category-nav-item-content">
                  <span style={styles.categoryNavIcon} className="category-nav-icon">{category.icon}</span>
                  <span style={{
                    ...styles.categoryNavName,
                    ...(selectedCategory === category.id && { color: "white" })
                  }} className="category-nav-name">{category.name}</span>
                </div>
                <span style={{
                  ...styles.categoryNavCount,
                  ...(selectedCategory === category.id && { backgroundColor: "#DDE8ED", color: "#123249" })
                }} className="category-nav-count">{category.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <main style={styles.mainContent} className="main-content">
        {loading ? (
          <div style={styles.loadingContainer} className="loading-container">
            <p>Loading products from database...</p>
          </div>
        ) : error ? (
          <div style={{textAlign: 'center', padding: '50px 20px', color: '#447793'}}>
            <p>{error}</p>
            <button 
              onClick={fetchProductsFromDatabase}
              style={{
                marginTop: '15px',
                padding: '8px 16px',
                backgroundColor: '#447793',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '0.9rem',
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
            >
              Retry Connection
            </button>
          </div>
        ) : selectedCategory === "all" ? (
          categories.map((category) => (
            category.products.length > 0 && (
              <section key={category.id} id={`category-${category.id}`} style={styles.categorySection} className="category-section">
                <div style={styles.categorySectionInner} className="category-section-inner">
                  <div style={styles.categoryHeader} className="category-header">
                    <div>
                      <h3 style={styles.categoryTitle} className="category-title">
                        <span>{category.icon}</span>
                        {category.name}
                      </h3>
                      <p style={styles.categoryDescription} className="category-description">
                        {category.description} • {category.count} products
                      </p>
                    </div>
                    <button
                      style={styles.viewAllButton}
                      className="view-all-button"
                      onClick={() => handleCategorySelect(category.id)}
                    >
                      View All <ChevronRight />
                    </button>
                  </div>

                  <div style={styles.categoryProductsGrid} className="category-products-grid">
                    {category.products.slice(0, 4).map((product) => (
                      <div
                        key={product.id}
                        style={styles.categoryProductCard}
                        className="category-product-card"
                      >
                        {product.tags && product.tags.includes("best-seller") && (
                          <div style={styles.categoryProductBadge} className="category-product-badge">Best Seller</div>
                        )}
                        {product.tags && product.tags.includes("new-arrival") && (
                          <div
                            style={{
                              ...styles.categoryProductBadge,
                              backgroundColor: "#2D5A74",
                            }}
                            className="category-product-badge new-badge"
                          >
                            New
                          </div>
                        )}

                        <button
                          style={styles.categoryWishlistButton}
                          className="category-wishlist-button"
                          onClick={() => toggleWishlist(product.id)}
                        >
                          <HeartIcon filled={wishlist.includes(product.id)} />
                        </button>

                        <button
                          style={styles.categoryCompareButton}
                          className="category-compare-button"
                          onClick={() => toggleCompare(product.id)}
                        >
                          <CompareIcon />
                        </button>

                        <div style={styles.categoryProductImage} className="category-product-image">
                          <img 
                            src={product.image} 
                            alt={product.name}
                            style={styles.productImageTag}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = getDefaultImage(product.category);
                            }}
                          />
                        </div>

                        <div style={styles.categoryProductContent} className="category-product-content">
                          <h3 style={styles.categoryProductName} className="category-product-name">{product.name}</h3>
                          <p style={styles.categoryProductDescription} className="category-product-description">
                            {product.description}
                          </p>

                          <div style={styles.categoryProductPrice} className="category-product-price">
                            <span style={styles.categoryCurrentPrice} className="category-current-price">
                              <span style={styles.categoryPriceSymbol} className="category-price-symbol">₹</span>
                              {product.price.toLocaleString()}
                            </span>
                            {product.originalPrice > product.price && (
                              <>
                                <span style={styles.categoryOriginalPrice} className="category-original-price">
                                  ₹{product.originalPrice.toLocaleString()}
                                </span>
                                <span style={styles.categoryDiscountBadge} className="category-discount-badge">
                                  Save ₹
                                  {(
                                    product.originalPrice - product.price
                                  ).toLocaleString()}
                                </span>
                              </>
                            )}
                          </div>

                          <div style={styles.categoryProductRating} className="category-product-rating">
                            <div style={{color: "#447793"}}>
                              {"★".repeat(Math.floor(product.rating))}
                              {"☆".repeat(5 - Math.floor(product.rating))}
                            </div>
                            <span style={{color: "#2D5A74"}}>
                              ({product.reviews} reviews)
                            </span>
                          </div>

                          <div style={styles.categoryProductActions} className="category-product-actions">
                            <button
                              style={{
                                ...styles.cardActionButton,
                                ...styles.enquiryBtn,
                              }}
                              className="card-action-button enquiry-btn"
                              onClick={() => handleEnquiryNow(product)}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#128C7E")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#25D366")
                              }
                            >
                              <WhatsAppIcon /> Enquire
                            </button>
                            <button
                              style={{
                                ...styles.cardActionButton,
                                ...styles.callBtn,
                              }}
                              className="card-action-button call-btn"
                              onClick={() => addToCart(product)}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#123249")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#2D5A74")
                              }
                            >
                              🛒 Add to Cart
                            </button>
                            <button
                              style={{
                                ...styles.cardActionButton,
                                ...styles.freeDemoBtn,
                              }}
                              className="card-action-button free-demo-btn"
                              onClick={() => handleFreeDemo(product)}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#2D5A74")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#447793")
                              }
                            >
                              📅 Free Demo
                            </button>
                            <button
                              style={{
                                ...styles.cardActionButton,
                                ...styles.viewDetailsBtn,
                              }}
                              className="card-action-button view-details-btn"
                              onClick={() => viewProductDetails(product.id)}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#2D5A74")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#447793")
                              }
                            >
                              👁️ View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            )
          ))
        ) : (
          (() => {
            const category = categories.find(cat => cat.id === selectedCategory);
            return category && category.products.length > 0 ? (
              <section id={`category-${category.id}`} style={styles.categorySection} className="category-section">
                <div style={styles.categorySectionInner} className="category-section-inner">
                  <div style={styles.categoryHeader} className="category-header">
                    <div>
                      <h3 style={styles.categoryTitle} className="category-title">
                        <span>{category.icon}</span>
                        {category.name}
                      </h3>
                      <p style={styles.categoryDescription} className="category-description">
                        {category.description} • {category.count} products
                      </p>
                    </div>
                    <button
                      style={styles.viewAllButton}
                      className="view-all-button"
                      onClick={() => setSelectedCategory("all")}
                    >
                      Back to All Categories <ChevronRight />
                    </button>
                  </div>

                  {filteredProducts.length === 0 ? (
                    <div style={styles.emptyState} className="empty-state">
                      <div
                        style={{
                          fontSize: "3rem",
                          color: "#447793",
                          marginBottom: "15px",
                        }}
                      >
                        ☀️
                      </div>
                      <h3>No products found</h3>
                      <p>Try adjusting your filters or search terms</p>
                    </div>
                  ) : (
                    <div style={styles.categoryProductsGrid} className="category-products-grid">
                      {filteredProducts.map((product) => (
                        <div
                          key={product.id}
                          style={styles.categoryProductCard}
                          className="category-product-card"
                        >
                          {product.tags && product.tags.includes("best-seller") && (
                            <div style={styles.categoryProductBadge} className="category-product-badge">Best Seller</div>
                          )}
                          {product.tags && product.tags.includes("new-arrival") && (
                            <div
                              style={{
                                ...styles.categoryProductBadge,
                                backgroundColor: "#2D5A74",
                              }}
                              className="category-product-badge new-badge"
                            >
                              New
                            </div>
                          )}

                          <button
                            style={styles.categoryWishlistButton}
                            className="category-wishlist-button"
                            onClick={() => toggleWishlist(product.id)}
                          >
                            <HeartIcon filled={wishlist.includes(product.id)} />
                          </button>

                          <button
                            style={styles.categoryCompareButton}
                            className="category-compare-button"
                            onClick={() => toggleCompare(product.id)}
                          >
                            <CompareIcon />
                          </button>

                          <div style={styles.categoryProductImage} className="category-product-image">
                            <img 
                              src={product.image} 
                              alt={product.name}
                              style={styles.productImageTag}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = getDefaultImage(product.category);
                              }}
                            />
                          </div>

                          <div style={styles.categoryProductContent} className="category-product-content">
                            <h3 style={styles.categoryProductName} className="category-product-name">{product.name}</h3>
                            <p style={styles.categoryProductDescription} className="category-product-description">
                              {product.description}
                            </p>

                            <div style={styles.categoryProductPrice} className="category-product-price">
                              <span style={styles.categoryCurrentPrice} className="category-current-price">
                                <span style={styles.categoryPriceSymbol} className="category-price-symbol">₹</span>
                                {product.price.toLocaleString()}
                              </span>
                              {product.originalPrice > product.price && (
                                <>
                                  <span style={styles.categoryOriginalPrice} className="category-original-price">
                                    ₹{product.originalPrice.toLocaleString()}
                                  </span>
                                  <span style={styles.categoryDiscountBadge} className="category-discount-badge">
                                    Save ₹
                                    {(
                                      product.originalPrice - product.price
                                    ).toLocaleString()}
                                  </span>
                                </>
                              )}
                            </div>

                            <div style={styles.categoryProductRating} className="category-product-rating">
                              <div style={{color: "#447793"}}>
                                {"★".repeat(Math.floor(product.rating))}
                                {"☆".repeat(5 - Math.floor(product.rating))}
                              </div>
                              <span style={{color: "#2D5A74"}}>
                                ({product.reviews} reviews)
                              </span>
                            </div>

                            <div style={styles.categoryProductActions} className="category-product-actions">
                              <button
                                style={{
                                  ...styles.cardActionButton,
                                  ...styles.enquiryBtn,
                                }}
                                className="card-action-button enquiry-btn"
                                onClick={() => handleEnquiryNow(product)}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#128C7E")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#25D366")
                                }
                              >
                                <WhatsAppIcon /> Enquire
                              </button>
                              <button
                                style={{
                                  ...styles.cardActionButton,
                                  ...styles.callBtn,
                                }}
                                className="card-action-button call-btn"
                                onClick={() => addToCart(product)}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#123249")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#2D5A74")
                                }
                              >
                                🛒 Add to Cart
                              </button>
                              <button
                                style={{
                                  ...styles.cardActionButton,
                                  ...styles.freeDemoBtn,
                                }}
                                className="card-action-button free-demo-btn"
                                onClick={() => handleFreeDemo(product)}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#2D5A74")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#447793")
                                }
                              >
                                📅 Free Demo
                              </button>
                              <button
                                style={{
                                  ...styles.cardActionButton,
                                  ...styles.viewDetailsBtn,
                                }}
                                className="card-action-button view-details-btn"
                                onClick={() => viewProductDetails(product.id)}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#2D5A74")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.backgroundColor = "#447793")
                                }
                              >
                                👁️ View Details
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </section>
            ) : (
              <div style={styles.emptyState} className="empty-state">
                <div
                  style={{
                    fontSize: "3rem",
                    color: "#447793",
                    marginBottom: "15px",
                  }}
                >
                  ☀️
                </div>
                <h3>No products found in this category</h3>
                <p>Try selecting a different category</p>
              </div>
            );
          })()
        )}
      </main>

      <div
        style={{
          ...styles.cartSidebar,
          ...(cartOpen && styles.cartSidebarOpen),
        }}
        className="cart-sidebar"
      >
        <div style={styles.cartHeader} className="cart-header">
          <h3 style={styles.cartTitle} className="cart-title">Shopping Cart ({cart.length})</h3>
          <button style={styles.cartClose} className="cart-close" onClick={toggleCart}>
            ×
          </button>
        </div>

        <div style={styles.cartItems} className="cart-items">
          {cart.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#2D5A74",
              }}
            >
              <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🛒</div>
              <h4>Your cart is empty</h4>
              <p>Add some products to get started</p>
            </div>
          ) : (
            cart.map((item) => (
              <div key={item.id} style={styles.cartItem} className="cart-item">
                <div style={styles.cartItemImage} className="cart-item-image">
                  <img 
                    src={item.image} 
                    alt={item.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = getDefaultImage(item.category);
                    }}
                  />
                </div>
                <div style={styles.cartItemContent} className="cart-item-content">
                  <div style={styles.cartItemName} className="cart-item-name">{item.name}</div>
                  <div style={styles.cartItemPrice} className="cart-item-price">
                    ₹{item.price.toLocaleString()}
                  </div>
                  <div style={styles.cartItemActions} className="cart-item-actions">
                    <button
                      style={styles.quantityButton}
                      className="quantity-button"
                      onClick={() =>
                        updateCartQuantity(item.id, item.quantity - 1)
                      }
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={item.quantity}
                      onChange={(e) =>
                        updateCartQuantity(item.id, parseInt(e.target.value))
                      }
                      style={styles.quantityInput}
                      className="quantity-input"
                      min="1"
                    />
                    <button
                      style={styles.quantityButton}
                      className="quantity-button"
                      onClick={() =>
                        updateCartQuantity(item.id, item.quantity + 1)
                      }
                    >
                      +
                    </button>
                    <button
                      style={styles.removeButton}
                      className="remove-button"
                      onClick={() => removeFromCart(item.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {cart.length > 0 && (
          <div style={styles.cartFooter} className="cart-footer">
            <div style={styles.cartTotal} className="cart-total">
              <span>Subtotal:</span>
              <span>₹{cartTotal.toLocaleString()}</span>
            </div>
            {cartSavings > 0 && (
              <div style={styles.cartSavings} className="cart-savings">
                You save: ₹{cartSavings.toLocaleString()}
              </div>
            )}
            <button
              style={styles.checkoutButton}
              className="checkout-button"
              onClick={() => {
                alert("Proceeding to checkout!");
                setCartOpen(false);
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2D5A74'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#447793'}
            >
              Proceed to Checkout
            </button>
          </div>
        )}
      </div>

      <div style={styles.chatbotContainer}>
        <button
          style={{
            ...styles.chatToggleBtn,
            animation: chatbotHover
              ? "pulse 0.5s infinite"
              : "pulse 2s infinite",
          }}
          className="chat-toggle-btn"
          onClick={() => setIsChatOpen(!isChatOpen)}
          onMouseEnter={() => setChatbotHover(true)}
          onMouseLeave={() => setChatbotHover(false)}
        >
          💬
        </button>

        <div style={{
          ...styles.chatWindow,
          ...(isChatOpen && styles.chatWindowOpen)
        }} className="chat-window">
          <div style={styles.chatHeader} className="chat-header">
            <div style={styles.headerInfo} className="header-info">
              <div style={styles.headerIcon} className="header-icon">☀️</div>
              <div>
                <h3 style={styles.chatHeaderTitle} className="chat-header-title">Blue Sky Energy</h3>
                <p style={styles.chatHeaderSubtitle} className="chat-header-subtitle">
                  Product Expert & Pricing
                </p>
              </div>
            </div>
            <button
              style={styles.closeChatBtn}
              className="close-chat-btn"
              onClick={() => setIsChatOpen(false)}
            >
              <XIcon />
            </button>
          </div>

          {quickReplies.length > 0 && (
            <div style={styles.quickReplies} className="quick-replies">
              {quickReplies.map((option, index) => (
                <button
                  key={index}
                  style={styles.replyBtn}
                  className="reply-btn"
                  onClick={() => handleQuickReply(option)}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#447793";
                    e.target.style.color = "white";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "white";
                    e.target.style.color = "#123249";
                    e.target.style.transform = "none";
                  }}
                >
                  {option}
                </button>
              ))}
            </div>
          )}

          <div style={styles.chatMessages} className="chat-messages">
            {chatMessages.map((msg) => (
              <div
                key={msg.id}
                style={{
                  ...styles.message,
                  ...(msg.sender === "bot"
                    ? styles.botMessage
                    : styles.userMessage),
                }}
                className="message"
              >
                {msg.text}
                <span style={styles.messageTime} className="message-time">{msg.time}</span>
              </div>
            ))}
          </div>

          <div style={styles.chatInputArea} className="chat-input-area">
            <div style={styles.inputWrapper} className="input-wrapper">
              <input
                type="text"
                value={chatInput}
                onChange={(e) => setChatInput(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Ask about products, prices, installation..."
                style={styles.chatInput}
                className="chat-input"
                onFocus={(e) => (e.target.style.borderColor = "#447793")}
                onBlur={(e) => (e.target.style.borderColor = "#DDE8ED")}
              />
              <button
                style={styles.sendBtn}
                className="send-btn"
                onClick={handleChatSend}
                onMouseEnter={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #2D5A74, #123249)";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "linear-gradient(135deg, #447793, #2D5A74)";
                  e.target.style.transform = "scale(1)";
                }}
              >
                📤
              </button>
            </div>
            <p style={styles.footerText} className="footer-text">
              {allProducts.length}+ Products • 25-year Warranties • 1000+ Happy Customers
            </p>
          </div>
        </div>
      </div>

      <footer style={styles.footer}>
        <div style={styles.footerContent} className="footer-content">
          <h2 style={styles.footerTitle} className="footer-title">Blue Sky Energy</h2>
          <p style={styles.footerText} className="footer-text">
            Your trusted partner for solar energy solutions. We provide
            high-quality solar products with expert installation and lifetime
            support. Go green with Blue Sky Energy.
          </p>

          <div style={styles.contactInfo} className="contact-info">
            <div style={styles.contactItem} className="contact-item">
              <PhoneIcon />
              <span>+91 80879 32436</span>
            </div>
            <div style={styles.contactItem} className="contact-item">
              <span>📧</span>
              <span>info@blueskyenergy.in</span>
            </div>
          </div>

          <p style={{ ...styles.footerText, fontSize: "0.85rem" }}>
            © 2024 Blue Sky Energy. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Products;